import { Component, OnInit, Input, Output, EventEmitter,AfterViewInit,
  OnChanges } from '@angular/core';
import * as globalVariables from "../../commonVariableList/addInvoice";
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { IrFieldsService } from '../../shared/services/ir-fields.service';
import { CompanySetupService } from '../../shared/services/company-setup.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { EesDesService } from '../../shared/services/ees-des.service';

@Component({
  selector: 'app-generic-grand-table', templateUrl: './generic-grand-table.component.html', styleUrls: ['./generic-grand-table.component.scss'],
  providers:[CompanySetupService,WebServiceService]
})
export class GenericGrandTableComponent implements OnInit,AfterViewInit, OnChanges {
  @Input() tableDetails: any;
  @Input() tagDetails:any;
  recurrence_table:any=[];
  commonVariableList: any =
    {
      "modalDetails": { "is_view": false },
      sectionList:[],
      "adhoc_data":{},
      "is_deaprtment_list":false,
     chequeList:[],
      "irn_grn_other_info":[],irn_grn_other_info_total_row:{},
      'extra_data_list':{'title':'','columnList':[],'items':[]},
      "is_account_type": false, "is_customer_allocation_visible": false,       "is_department_allocation_visible": false,
      "is_allocate_auto_populate": false, "is_allocate_populate_and_summarize": false,
      "account_type_field_list": [], "department_allocation_list": [],
      "acceptedList": [], "rejectedList": [], "grn_acceptedList": [], "grn_rejectedList": [], "columnList": [], "items": [], "extraGrandColumnList": [], "extraItems": [], "is_goods": false,
      "totalList": { 'title': '', "amount": '',is_ddc_view:false, "is_view": false, "is_mpr_boq": false },"invoice_allocate_to_employee": false,"employee_allocation_list":[],
      'payment_details' : [], "diff_items": [], "multi_attachments": [],
    }
    is_dimension:boolean=false;
  @Output()
  sendAction = new EventEmitter()
  DiscountAmount: boolean;
  CgstVisible: boolean;
  SgstVisible: boolean;
  IgstVisible: boolean;
  UgstVisible: boolean;
  CessVisible: boolean;
  OthertaxVisible: boolean;
  TotaltaxVisible: boolean;
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  foreign_round_grandTotal: any = "";
  foreign_final_total_roundoff: any = "";
  showPaymentDetailsTable: boolean = false;
  constructor(public eesdesService:EesDesService,private toasterService: ToasterService, private webService: WebServiceService, public irFields: IrFieldsService, public comanySetup:CompanySetupService,public _localStorageService: LocalStorageService) { }
  company_setup: any = {};
  stillLoading:boolean=false;
  page_url:any=window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  country_data:any={}
  attachment:any=[]
  advPaymentPoSavedAttachments:any=[]
  vendorDocuments:any=[]
  attachment_title:any='';
  setup:any={}

  showAvailableBudget:boolean=true;
  showAmounts:boolean=true;
  showRcmGstData:boolean = false;
  rcmGstData:any={
    "totJournalCgst":0,
    "totJournalSgst":0,
    "totJournalIgst":0,
    "totJournalCess":0,
    "totJournalUgst":0,
    "totJournalOtherTax":0,
    "totJournalTax":0,
  };
  ngOnInit() {
    //console.log('page_url'+this.page_url);
    this.attachment=[];
    this.advPaymentPoSavedAttachments=[];
    this.vendorDocuments=[];
    this.commonVariableList.is_deaprtment_list=false;
    this.commonVariableList.adhoc_data={};
    this.commonVariableList.sectionList=[];
    let t:any={};
    t = this.eesdesService.get('country_data',localStorage.getItem('country_data')) ? this.eesdesService.get('country_data',localStorage.getItem('country_data')) : {};
    // //console.log(t);
    if(t.country_id!==''&&t.country_id!==undefined&&t.country_id!==null)
    {
      this.country_data=t;
    }
    if (this.tableDetails.id) {
      this.setup=this.tableDetails.setup?this.tableDetails.setup:{}
      this.setup.is_setup=this.tableDetails.is_setup?this.tableDetails.is_setup:false;

      this.tagDetails=this.tagDetails?this.tagDetails:{'div_size':'col-sm-6 irndata','is_custom':false}
      this.is_Garnd_Table_Visible();
      this.commonVariableList.is_account_type = false;
      this.commonVariableList.is_customer_allocation_visible = false;
      this.commonVariableList.is_department_allocation_visible = false;
      this.commonVariableList.invoice_allocate_to_employee = false;

      this.commonVariableList.department_allocation_list = []
      this.commonVariableList.account_type_field_list = []
      this.commonVariableList.customer_allocation_list = []
      this.commonVariableList.chequeList=[];
      this.commonVariableList.employee_allocation_list = []
      this.commonVariableList.payment_details = []

      this.commonVariableList.items = []; this.commonVariableList.extraItems = [];
      this.commonVariableList.extra_data_list.columnList = [];
      this.commonVariableList.extra_data_list.items = [];
      if(this.setup.is_setup)
      {
        this.setSetupData(this.setup);
      }
      else
      {
      this.GetCompanySetUpData();
      }
    }
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? (this._localStorageService.getCompanyTheme()) : "#035168";
    this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? (this._localStorageService.getCompanyThemeColor() ) : "#FFFFFF";
  }
  ngOnChanges() {
    if (!this.tableDetails || !this.tableDetails.id) {
      return;
    }
    const isIrReport = this.irFields.isIrReportTableId(this.tableDetails.id);
    if (
      isIrReport &&
      this.tableDetails.is_setup &&
      this.tableDetails.setup &&
      this.tableDetails.data
    ) {
      this.setup = this.tableDetails.setup;
      this.setup.is_setup = true;
      this.company_setup = this.tableDetails.setup;
      if (!this.irFields.isIrFieldsTableApplied(this.company_setup)) {
        this.irFields.applyIrFieldsTable(this.company_setup);
      }
      this.apiCall();
      this.stillLoading = false;
    }
  }
  GetCompanySetUpData() {
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '')
{
  return false;
}
    let req = {
    }


    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup.custome_name_for_total_discounted_amount_in_po_module=this.company_setup.custome_name_for_total_discounted_amount_in_po_module?this.company_setup.custome_name_for_total_discounted_amount_in_po_module:'Total Discounted Amount';
          this.company_setup.comma_separate_currency_code = this.company_setup.comma_separate_currency_code ? this.company_setup.comma_separate_currency_code : 'IND';
          this.company_setup.is_enable_comma_separate_price = this.company_setup.is_enable_comma_separate_price ? this.company_setup.is_enable_comma_separate_price : '0';
          this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : '2';
          this.company_setup.show_vendor_document_upload = this.company_setup.show_vendor_document_upload ? this.company_setup.show_vendor_document_upload : '0';
          this.company_setup.questionnaire_upload_table_in_irn = this.company_setup.questionnaire_upload_table_in_irn ? this.company_setup.questionnaire_upload_table_in_irn : [];
          this.company_setup.enable_questionnarie_files = this.company_setup.enable_questionnarie_files ? this.company_setup.enable_questionnarie_files : "0";
          this.company_setup.total_tds_related_row_visible = this.company_setup.total_tds_related_row_visible ? this.company_setup.total_tds_related_row_visible: '1';
          this.company_setup.in_po_gst_will_calculate_on=this.company_setup.in_po_gst_will_calculate_on?this.company_setup.in_po_gst_will_calculate_on:'with_gst'
        
        }
        else {
          this.toasterService.pop('error', "Error", data.message);
        }
        this.setSetupData(data.response);
      }, error => {
        this.stillLoading=false;
        this.toasterService.pop("error", "Error", "Something Went Wrong");

      }
    )
  }
  setSetupData(data)
  {
    this.company_setup = {}
    this.company_setup.invoice_extra_columns =  [];
    this.company_setup.invoiceJESettings=[];
    this.stillLoading=true;
    this.company_setup.emp_code_visible_allocate_center=this.company_setup.emp_code_visible_allocate_center?this.company_setup.emp_code_visible_allocate_center:'0'
    this.company_setup.invoice_summary_title=this.company_setup.invoice_summary_title?this.company_setup.invoice_summary_title:{'main_title_1':'','main_title_2':'','main_title_3':''}
    this.company_setup.invoice_summary_title.main_title_1=this.company_setup.invoice_summary_title.main_title_1?this.company_setup.invoice_summary_title.main_title_1:'';
    this.company_setup.invoice_summary_title.main_title_2=this.company_setup.invoice_summary_title.main_title_1?this.company_setup.invoice_summary_title.main_title_2:'';
    this.company_setup.invoice_summary_title.main_title_3=this.company_setup.invoice_summary_title.main_title_1?this.company_setup.invoice_summary_title.main_title_3:'';
    this.company_setup.custome_name_for_total_discounted_amount_in_po_module=this.company_setup.custome_name_for_total_discounted_amount_in_po_module?this.company_setup.custome_name_for_total_discounted_amount_in_po_module:'Total Discounted Amount';
    this.company_setup.show_fc_amount_field_in_allocate_cost_table=this.company_setup.show_fc_amount_field_in_allocate_cost_table?this.company_setup.show_fc_amount_field_in_allocate_cost_table:'0';
    this.company_setup.po_summary_title=this.company_setup.po_summary_title?this.company_setup.po_summary_title:{'main_title_1':''}
    this.company_setup.po_summary_title.main_title_1=this.company_setup.po_summary_title.main_title_1?this.company_setup.po_summary_title.main_title_1:'';
   
    this.company_setup.irn_grn_other_info =[];

    this.company_setup.po_adhoc_advance_payment = [];

    this.company_setup = data ? data : {}
    this.company_setup.display_gstin_with_cost_center_and_vendor = this.company_setup.display_gstin_with_cost_center_and_vendor ? this.company_setup.display_gstin_with_cost_center_and_vendor : '0';
    this.company_setup.gstin_display_label = this.company_setup.gstin_display_label ? this.company_setup.gstin_display_label : 'GST';
    this.company_setup.invoiceJESettings= this.company_setup.invoiceJESettings? this.company_setup.invoiceJESettings:[]
    this.company_setup.tot_val_visible_in_pr=this.company_setup.tot_val_visible_in_pr?this.company_setup.tot_val_visible_in_pr:'0'
    this.company_setup.grand_tot_visible_in_pr=this.company_setup.grand_tot_visible_in_pr?this.company_setup.grand_tot_visible_in_pr:'0'
    this.company_setup.preferred_vend_visible_in_pr=this.company_setup.preferred_vend_visible_in_pr?this.company_setup.preferred_vend_visible_in_pr:'0'
    this.company_setup.tot_qty_visible_in_pr=this.company_setup.tot_qty_visible_in_pr?this.company_setup.tot_qty_visible_in_pr:'0'
    this.irFields.applyIrFieldsTable(this.company_setup);
    const isIrGrandReport =
      this.tableDetails && this.irFields.isIrReportTableId(this.tableDetails.id);
    if (isIrGrandReport) {
      const parentSetupReady =
        this.setup &&
        this.setup.is_setup &&
        this.irFields.hasIrFieldsTableConfig(this.company_setup);
      if (parentSetupReady) {
        this.apiCall();
        this.stillLoading = false;
        return;
      }
      this.irFields.loadIrCompanyMetaTabwise(this.company_setup, () => {
        this.apiCall();
        this.stillLoading = false;
      });
      return;
    }

    this.company_setup.is_tds_visible_at_location_level=this.company_setup.is_tds_visible_at_location_level?this.company_setup.is_tds_visible_at_location_level:'0'
    this.company_setup.is_tds_amount_visible_at_location_level=this.company_setup.is_tds_amount_visible_at_location_level?this.company_setup.is_tds_amount_visible_at_location_level:'0'
    this.company_setup.is_tds_rate_visible_at_location_level=this.company_setup.is_tds_rate_visible_at_location_level?this.company_setup.is_tds_rate_visible_at_location_level:'0'

    this.company_setup.custom_name_inv_form_12=this.company_setup.custom_name_inv_form_12?this.company_setup.custom_name_inv_form_12:'Form 12';

    this.company_setup.is_form_12_mandatory=this.company_setup.is_form_12_mandatory?this.company_setup.is_form_12_mandatory:'0'
    this.company_setup.is_form_12_visible=this.company_setup.is_form_12_visible?this.company_setup.is_form_12_visible:'0'

    this.company_setup.custom_name_for_je_table=this.company_setup.custom_name_for_je_table?this.company_setup.custom_name_for_je_table:'JE Entry Preview'
    this.company_setup.is_project_visible_in_allocate_costcenter_in_inv=this.company_setup.is_project_visible_in_allocate_costcenter_in_inv?this.company_setup.is_project_visible_in_allocate_costcenter_in_inv:'0'
    this.company_setup.auto_populate = this.company_setup.auto_populate ? this.company_setup.auto_populate : '0';
    this.company_setup.populate_and_summarize = this.company_setup.populate_and_summarize ? this.company_setup.populate_and_summarize : '0';

    this.company_setup.default_currency_code=this.company_setup.default_currency_code?this.company_setup.default_currency_code:'INR';
    this.company_setup.po_adhoc_advance_payment = this.company_setup.po_adhoc_advance_payment?this.company_setup.po_adhoc_advance_payment:[]

    this.company_setup.in_invoice_is_paid_amount_visible_for_ddc=this.company_setup.in_invoice_is_paid_amount_visible_for_ddc?this.company_setup.in_invoice_is_paid_amount_visible_for_ddc:'0'
    this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc=this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc?this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc:'0'
    this.company_setup.in_invoice_is_debit_amount_visible_for_ddc=this.company_setup.in_invoice_is_debit_amount_visible_for_ddc?this.company_setup.in_invoice_is_debit_amount_visible_for_ddc:'0'

    this.company_setup.irn_grn_other_info =this.company_setup.irn_grn_other_info?this.company_setup.irn_grn_other_info:[];

    this.company_setup.is_irn_grn_other_info_visible= this.company_setup.irn_grn_other_info.some((v)=>{return v.is_visible_on_irn||v.is_visible_on_grn})?'1':'0'
    this.company_setup.custome_name_for_total_discounted_amount_in_po_module=this.company_setup.custome_name_for_total_discounted_amount_in_po_module?this.company_setup.custome_name_for_total_discounted_amount_in_po_module:'Total Discounted Amount';
    this.company_setup.generice_ui_paragraph_color_code= this.company_setup.generice_ui_paragraph_color_code? this.company_setup.generice_ui_paragraph_color_code:'#53a75c';
    this.company_setup.generice_ui_heading_color_code= this.company_setup.generice_ui_heading_color_code? this.company_setup.generice_ui_heading_color_code:'#333';

    this.company_setup.invoice_summary_title=this.company_setup.invoice_summary_title?this.company_setup.invoice_summary_title:{};
    this.company_setup.invoice_summary_title.main_title_1_columns=this.company_setup.invoice_summary_title.main_title_1_columns?this.company_setup.invoice_summary_title.main_title_1_columns:{};
    this.company_setup.custom_name_for_branch_master = this.company_setup.custom_name_for_branch_master ? this.company_setup.custom_name_for_branch_master : 'Branch Master';
    this.company_setup.custom_name_for_sp_partner_master = this.company_setup.custom_name_for_sp_partner_master ? this.company_setup.custom_name_for_sp_partner_master : 'Sp Partner Master';
    this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "dd-mm-yyyy";
    this.company_setup.po_summary_title=this.company_setup.po_summary_title?this.company_setup.po_summary_title:{};
    this.company_setup.po_summary_title.main_title_1_columns=this.company_setup.po_summary_title.main_title_1_columns?this.company_setup.po_summary_title.main_title_1_columns:{};
   
    if( this.company_setup.invoice_summary_title.main_title_1_columns)
    {
      for(let i of  this.company_setup.invoice_summary_title.main_title_1_columns)
      {
        i.is_visible=i.is_visible?i.is_visible:'';

        if(i.id=='po_advance_amount_percentage'&& (i.is_visible==undefined|| i.is_visible==''))
        {
          i.is_visible=false;
        }
        else
        {
          i.is_visible=i.is_visible?i.is_visible:true;

        }

      }
    }
  this.company_setup.is_upload_annexure_button_visible_in_po=this.company_setup.is_upload_annexure_button_visible_in_po?this.company_setup.is_upload_annexure_button_visible_in_po:'0';
  this.company_setup.po_annexure_template_for_upload = this.company_setup.po_annexure_template_for_upload ? this.company_setup.po_annexure_template_for_upload :[];

  this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '';
  if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
      this.company_setup.product_catalog_id = '1'
    }
    // this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';

    this.commonVariableList.is_mpr_boq = false;
    this.company_setup.merge_grn_irn = this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0';

    this.company_setup.irn_expiry_details_for_accepted = this.company_setup.irn_expiry_details_for_accepted ? this.company_setup.irn_expiry_details_for_accepted : '0';
    this.company_setup.irn_expiry_details_for_rejected = this.company_setup.irn_expiry_details_for_rejected ? this.company_setup.irn_expiry_details_for_rejected : '0';

    this.company_setup.irn_expiry_details_for_accepted_batch_visible = this.company_setup.irn_expiry_details_for_accepted_batch_visible ? this.company_setup.irn_expiry_details_for_accepted_batch_visible : '0'
    this.company_setup.irn_expiry_details_for_accepted_expiry_date_visible = this.company_setup.irn_expiry_details_for_accepted_expiry_date_visible ? this.company_setup.irn_expiry_details_for_accepted_expiry_date_visible : '0'
    this.company_setup.irn_expiry_details_for_accepted_temperature_visible = this.company_setup.irn_expiry_details_for_accepted_temperature_visible ? this.company_setup.irn_expiry_details_for_accepted_temperature_visible : '0'
    this.company_setup.currency_icon = this.company_setup.currency_icon ? this.company_setup.currency_icon : '';

    this.company_setup.irn_expiry_details_for_rejected_batch_visible = this.company_setup.irn_expiry_details_for_rejected_batch_visible ? this.company_setup.irn_expiry_details_for_rejected_batch_visible : '0'
    this.company_setup.irn_expiry_details_for_rejected_expiry_date_visible = this.company_setup.irn_expiry_details_for_rejected_expiry_date_visible ? this.company_setup.irn_expiry_details_for_rejected_expiry_date_visible : '0'
    this.company_setup.irn_expiry_details_for_rejected_temperature_visible = this.company_setup.irn_expiry_details_for_rejected_temperature_visible ? this.company_setup.irn_expiry_details_for_rejected_temperature_visible : '0'

    this.company_setup.grn_expiry_details_for_accepted = this.company_setup.grn_expiry_details_for_accepted ? this.company_setup.grn_expiry_details_for_accepted : '0';
    this.company_setup.grn_expiry_details_for_rejected = this.company_setup.grn_expiry_details_for_rejected ? this.company_setup.grn_expiry_details_for_rejected : '0';

    this.company_setup.grn_expiry_details_for_accepted_batch_visible = this.company_setup.grn_expiry_details_for_accepted_batch_visible ? this.company_setup.grn_expiry_details_for_accepted_batch_visible : '0'
    this.company_setup.grn_expiry_details_for_accepted_expiry_date_visible = this.company_setup.grn_expiry_details_for_accepted_expiry_date_visible ? this.company_setup.grn_expiry_details_for_accepted_expiry_date_visible : '0'
    this.company_setup.grn_expiry_details_for_accepted_temperature_visible = this.company_setup.grn_expiry_details_for_accepted_temperature_visible ? this.company_setup.grn_expiry_details_for_accepted_temperature_visible : '0'
    this.company_setup.grn_expiry_details_for_accepted_barcode_visible = this.company_setup.grn_expiry_details_for_accepted_barcode_visible ? this.company_setup.grn_expiry_details_for_accepted_barcode_visible : '0'

    this.company_setup.grn_expiry_details_for_rejected_batch_visible = this.company_setup.grn_expiry_details_for_rejected_batch_visible ? this.company_setup.grn_expiry_details_for_rejected_batch_visible : '0'
    this.company_setup.grn_expiry_details_for_rejected_barcode_visible = this.company_setup.grn_expiry_details_for_rejected_barcode_visible ? this.company_setup.grn_expiry_details_for_rejected_barcode_visible : '0'
    this.company_setup.grn_expiry_details_for_rejected_expiry_date_visible = this.company_setup.grn_expiry_details_for_rejected_expiry_date_visible ? this.company_setup.grn_expiry_details_for_rejected_expiry_date_visible : '0'
    this.company_setup.grn_expiry_details_for_rejected_temperature_visible = this.company_setup.grn_expiry_details_for_rejected_temperature_visible ? this.company_setup.grn_expiry_details_for_rejected_temperature_visible : '0'
    this.company_setup.batch_number_custom_name = this.company_setup.batch_number_custom_name ? this.company_setup.batch_number_custom_name : 'BarCode'
    this.company_setup.is_advance_amt_visible_in_add_direct_po = this.company_setup.is_advance_amt_visible_in_add_direct_po ? this.company_setup.is_advance_amt_visible_in_add_direct_po : '0';
    this.company_setup.is_advance_amt_percentage_visible_in_add_direct_po = this.company_setup.is_advance_amt_percentage_visible_in_add_direct_po ? this.company_setup.is_advance_amt_percentage_visible_in_add_direct_po:'0';

    this.company_setup.is_discount_applicable_in_po = this.company_setup.is_discount_applicable_in_po ? this.company_setup.is_discount_applicable_in_po : '0'
    this.company_setup.discount_type_in_po = this.company_setup.discount_type_in_po ? this.company_setup.discount_type_in_po : '0'
    this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '';
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
      this.company_setup.product_catalog_id = '1'
    }

    // this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';
    this.company_setup.is_mpr_sku_visible = this.company_setup.is_mpr_sku_visible ? this.company_setup.is_mpr_sku_visible : '0';
    this.company_setup.is_mpr_unit_type_visible = this.company_setup.is_mpr_unit_type_visible ? this.company_setup.is_mpr_unit_type_visible : '0';
    this.company_setup.is_mpr_buffer_stock_visible = this.company_setup.is_mpr_buffer_stock_visible ? this.company_setup.is_mpr_buffer_stock_visible : '0';
    this.company_setup.invoice_extra_columns =this.company_setup.invoice_extra_columns?this.company_setup.invoice_extra_columns: [];
    let temp: any = [];
    temp = this.company_setup.invoice_extra_columns.filter((v) => { return v.id == 'grn_invoice' });
    if (temp.length != undefined && temp.length>0) {
      this.company_setup.invoice_extra_columns = [];
      this.company_setup.invoice_extra_columns = temp[0].columns ? temp[0].columns : [];
    }
    this.company_setup.proposed_pod_deduction_amount_visible=this.webService.is_column_visible(this.company_setup.invoice_extra_columns,'proposed_pod_deduction_amount',false);
      this.company_setup.proposed_cod_deduction_amount_visible=this.webService.is_column_visible(this.company_setup.invoice_extra_columns,'proposed_cod_deduction_amount',false);

      this.company_setup.approved_pod_deduction_amount_visible=this.webService.is_column_visible(this.company_setup.invoice_extra_columns,'approved_pod_deduction_amount',false);
      this.company_setup.approved_cod_deduction_amount_visible=this.webService.is_column_visible(this.company_setup.invoice_extra_columns,'approved_cod_deduction_amount',false);
      this.company_setup.custom_total_gst_visible = this.company_setup.custom_total_gst_visible ? this.company_setup.custom_total_gst_visible : '0'
      this.company_setup.invoice_in_summary_table_tds_amount_field_visible = this.company_setup.invoice_in_summary_table_tds_amount_field_visible?this.company_setup.invoice_in_summary_table_tds_amount_field_visible:'0';
      this.company_setup.invoice_in_summary_table_previous_tds_amount_field_visible = this.company_setup.invoice_in_summary_table_previous_tds_amount_field_visible?this.company_setup.invoice_in_summary_table_previous_tds_amount_field_visible:'0';
      this.company_setup.invoice_item_columnList = this.company_setup.invoice_item_columnList ? this.company_setup.invoice_item_columnList : []
      if (this.company_setup.invoice_item_columnList.length > 0) {
        this.company_setup.invoice_allocate_to_employee_visible = this.company_setup.invoice_item_columnList.some((v) => { return v.id == 'invoice_allocate_to_employee' && v.isVisible })
      }
      this.company_setup.round_off_fields_visible_in_invoice = this.company_setup.round_off_fields_visible_in_invoice ? this.company_setup.round_off_fields_visible_in_invoice : '0';
      this.company_setup.in_adhoc_advance_payment_pages_description_is_visible = this.company_setup.in_adhoc_advance_payment_pages_description_is_visible ? this.company_setup.in_adhoc_advance_payment_pages_description_is_visible : '0';
      this.company_setup.is_inv_debit_note_disable = this.company_setup.is_inv_debit_note_disable ? this.company_setup.is_inv_debit_note_disable : '0';

      this.company_setup.invoice_raiser_hide_tds = this.company_setup.invoice_raiser_hide_tds ? this.company_setup.invoice_raiser_hide_tds : '0';
      if(this.page_url != 'all-invoices' && this.page_url != 'draft-invoice') {
        this.company_setup.invoice_raiser_hide_tds = '0';
      }
      this.company_setup.is_budget_selection_at_item_level_in_product_table = this.company_setup.is_budget_selection_at_item_level_in_product_table ? this.company_setup.is_budget_selection_at_item_level_in_product_table : '0';
      this.company_setup.enable_concatenation_of_project_and_task_name = this.company_setup.enable_concatenation_of_project_and_task_name ? this.company_setup.enable_concatenation_of_project_and_task_name : '0';
      this.company_setup.rename_project = this.company_setup.rename_project ? this.company_setup.rename_project : 'Project';
      this.company_setup.rename_task = this.company_setup.rename_task ? this.company_setup.rename_task : 'Task';
      this.company_setup.show_Foriegn_hsn_percentage = this.company_setup.show_Foriegn_hsn_percentage ? this.company_setup.show_Foriegn_hsn_percentage : '0';
      this.company_setup.upload_file_for_custom_name = this.company_setup.upload_file_for_custom_name ? this.company_setup.upload_file_for_custom_name : "Custom name Upload File";
      this.company_setup.its_note_visibale = this.company_setup.its_note_visibale ? this.company_setup.its_note_visibale : "Note";      
      this.company_setup.questionnaire_upload_table_in_irn = this.company_setup.questionnaire_upload_table_in_irn ? this.company_setup.questionnaire_upload_table_in_irn : [];
      this.company_setup.attachments_visible_raise_po = this.company_setup.attachments_visible_raise_po ? this.company_setup.attachments_visible_raise_po : '0';
      this.company_setup.inv_rcm_applicable_visible = this.company_setup.inv_rcm_applicable_visible ? this.company_setup.inv_rcm_applicable_visible : '0';
    this.apiCall();
    this.stillLoading=false;
  }
  apiCall() {
    this.commonVariableList.columnList = []; this.commonVariableList.items = [];
    this.commonVariableList.extraGrandColumnList = []; this.commonVariableList.extraItems = [];
    this.commonVariableList.is_mpr_boq = false;
    this.stillLoading=true;
    switch (this.tableDetails.id) {

      case 'invoice_android_report':
        this.commonVariableList.columnList =[];
        this.commonVariableList.extraGrandColumnList =[]
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showAndroidInvoice(this.tableDetails.data);
        break;
        case 'recurring_invoicereport':
          this.commonVariableList.columnList = globalVariables.recurring_invoiceVariableList.grandColumnList;
          this.commonVariableList.extraGrandColumnList = globalVariables.recurring_invoiceVariableList.extraGrandColumnList;
          this.commonVariableList.extra_data_list.title='';
          this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
          this.attachment_title=this.company_setup.custom_name_inv_form_12;
          this.showRecurringInvoice(this.tableDetails.data);
          break;

      case 'invoicereport':
        this.commonVariableList.columnList = globalVariables.invoiceVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.invoiceVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.attachment_title=this.company_setup.custom_name_inv_form_12;
        this.showInvoice(this.tableDetails.data);
        break;
        case 'dcnotereport':
          this.commonVariableList.columnList = globalVariables.dcNoteVariableList.grandColumnList;
          this.commonVariableList.extraGrandColumnList = globalVariables.dcNoteVariableList.extraGrandColumnList;
          this.commonVariableList.extra_data_list.title='';
          this.commonVariableList.extra_data_list.items=[];
               this.commonVariableList.extra_data_list.columnList=[];
          this.showDCNote(this.tableDetails.data);
          break;
      case 'grnreport':
        this.commonVariableList.columnList = globalVariables.grnVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.grnVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showGrn(this.tableDetails.data);
        break;
      case 'irnreport':
        this.commonVariableList.columnList = globalVariables.irnVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.irnVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showIrn(this.tableDetails.data);
        break;
      case 'gatepassreport':
        this.showGatePass(this.tableDetails.data);
        break;
      case 'poreport':
        this.commonVariableList.columnList = globalVariables.poVariableList.grandColumnList;

        for(let i of this.commonVariableList.columnList){

          if(i.value == 'foreign_amount'){

            i.display = `Amount(${this.tableDetails.data.currency_code ? this.tableDetails.data.currency_code : this.company_setup.currency_icon})`;
          }
          if(i.value == 'foreign_amount' && this.tableDetails.data.is_different_document_currency == false){
            i.is_view = false;
            console.log(i.is_view);
          }
          if(i.value == 'foreign_amount' && this.tableDetails.data.is_different_document_currency == true){
            i.is_view = true;

            console.log(i.is_view);
          }
          if(i.value == 'discounted_amount'){
              i.display = this.company_setup.custome_name_for_total_discounted_amount_in_po_module;
            }
          if(i.value == 'title'){
            i.display = this.company_setup.po_summary_title.main_title_1 ? this.company_setup.po_summary_title.main_title_1 : '-';
          }
        }
        // console.log(this.tableDetails.data.is_different_document_currency);

        this.commonVariableList.extraGrandColumnList = globalVariables.poVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title=globalVariables.poVariableList.extra_data_list.title?globalVariables.poVariableList.extra_data_list.title:'';
        this.commonVariableList.extra_data_list.columnList=globalVariables.poVariableList.extra_data_list.records?globalVariables.poVariableList.extra_data_list.records:[]
        this.showPo(this.tableDetails.data);
        break;

      case 'mpreport':
        this.commonVariableList.columnList = globalVariables.mpVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.mpVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showMp(this.tableDetails.data);
        break;
        case 'logisticsreport':
          this.commonVariableList.columnList = globalVariables.logisticsVariableList.grandColumnList;
          this.commonVariableList.extraGrandColumnList = globalVariables.logisticsVariableList.extraGrandColumnList;
          this.commonVariableList.extra_data_list.title='';
          this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
          this.showLogistiics(this.tableDetails.data);
          break;
      case 'sireport':
        this.commonVariableList.columnList = globalVariables.siVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.siVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showSi(this.tableDetails.data);
        break;
      case 'prreport':
        this.commonVariableList.columnList = globalVariables.prVariableList.grandColumnList;

        // console.log("Column List: ", this.commonVariableList.columnList);

        for(let i of this.commonVariableList.columnList) {
          if(i.value == 'foreign_amount') {
            i.display = `Amount(${this.tableDetails.data.currency_code ? this.tableDetails.data.currency_code : this.company_setup.currency_icon})`;
          }
          if(i.value == 'foreign_amount' && this.tableDetails.data.is_different_document_currency == false) {
            i.is_view = false;
          }
          if(i.value == 'foreign_amount' && (this.tableDetails.data.is_different_document_currency == true || this.tableDetails.data.is_different_document_currency == '1')) {
            i.is_view = true;
          }
          // if(i.value == 'title'){
          //   i.display = this.company_setup.po_summary_title.main_title_1 ? this.company_setup.po_summary_title.main_title_1 : '-';
          // }
        }
        this.commonVariableList.extraGrandColumnList = globalVariables.prVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];

        

        this.showPr(this.tableDetails.data);
        break;
        case 'irreport':
        case 'ir_history_report':
        this.commonVariableList.columnList = globalVariables.irVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.irVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.irFields.hideIrGrandForeignColumns(this.commonVariableList.columnList);
        this.showIr(this.tableDetails.data);
        break;
      case 'mprreport':
        this.commonVariableList.columnList = globalVariables.mprVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.mprVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showMpr(this.tableDetails.data);
        break;
      case 'stnreport':
        this.commonVariableList.columnList = globalVariables.stnVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.stnVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showStn(this.tableDetails.data);
        break;
      case 'proformainvoicereport':
        this.commonVariableList.columnList = globalVariables.proformainvoiceVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.proformainvoiceVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showProformaInvoice(this.tableDetails.data);
        break;
      case 'salesOrderData':
        this.commonVariableList.columnList = globalVariables.SalesOrderVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.SalesOrderVariableList.extraGrandColumnList;
        // this.commonVariableList.columnList = globalVariables.proformainvoiceVariableList.grandColumnList;
        // this.commonVariableList.extraGrandColumnList = globalVariables.proformainvoiceVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showSalesOrderData(this.tableDetails.data);
        break;
      case 'salesinvoicereport':
        this.commonVariableList.columnList = globalVariables.salesinvoiceVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.salesinvoiceVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showSalesInvoice(this.tableDetails.data);
        break;
      case 'invoicepaymentreport':
        this.commonVariableList.columnList = globalVariables.invoicePaymentVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.invoicePaymentVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showInvoicePayment(this.tableDetails.data);
        break;
        case 'adhocpaymentreport':
          this.commonVariableList.columnList = []
          this.commonVariableList.extraGrandColumnList = globalVariables.adhocpaymentVariableList.extraGrandColumnList;
          this.commonVariableList.extra_data_list.title='';
          this.commonVariableList.extra_data_list.items=[];
          this.commonVariableList.extra_data_list.columnList=[];
          this.showAdhocPayment(this.tableDetails.data);
          break;
      case 'popaymentreport':
        this.commonVariableList.columnList = globalVariables.poPaymentVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.poPaymentVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showPoPayment(this.tableDetails.data);
        break;
      case 'salesOrderData':
        this.commonVariableList.columnList = globalVariables.poPaymentVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.poPaymentVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showsalesOrder(this.tableDetails.data);
        break;
      case 'my_advance_report':
        this.commonVariableList.columnList = globalVariables.myAdvancePaymentVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.myAdvancePaymentVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showMyadvanceData(this.tableDetails.data);
        break;
      case 'employee_advance_payment_report':
        this.commonVariableList.columnList = globalVariables.employeeAdvancePaymentVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.employeeAdvancePaymentVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];        this.commonVariableList.extra_data_list.columnList=[];
        this.showEmployeeAdvancePaymentData(this.tableDetails.data);
        break;
      case 'rfqNumberReport':
        this.commonVariableList.columnList = [];
        this.commonVariableList.extraGrandColumnList = [];
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];
        this.commonVariableList.extra_data_list.columnList=[];
        this.showRfqData(this.tableDetails.data)
        break; 
      case 'rfqResponseReport':
        this.commonVariableList.columnList = [];
        this.commonVariableList.extraGrandColumnList = [];
        this.commonVariableList.extra_data_list.title='';
        this.commonVariableList.extra_data_list.items=[];
        this.commonVariableList.extra_data_list.columnList=[];
        this.showRfqData(this.tableDetails.data)
        break;    
      case 'creditnotereport':
        this.commonVariableList.columnList = globalVariables.creditNoteVariableList.grandColumnList;
        this.commonVariableList.extraGrandColumnList = globalVariables.creditNoteVariableList.extraGrandColumnList;
        this.commonVariableList.extra_data_list.title = '';
        this.commonVariableList.extra_data_list.items = [];
        this.commonVariableList.extra_data_list.columnList = [];
        this.showVendorCreditNote(this.tableDetails.data);
        break;
      case 'productmaster':
        this.commonVariableList.columnList = [];
        this.commonVariableList.extraGrandColumnList = [];
        this.commonVariableList.extra_data_list.title = '';
        this.commonVariableList.extra_data_list.items = [];
        this.commonVariableList.extra_data_list.columnList = [];
        this.stillLoading = false;
        break;
        default:
        this.toasterService.pop('error', "Error", "Wrong Data For Summary Table");
    }
    this.stillLoading= this.tableDetails.id=="poreport" ? this.stillLoading :false;
  }
  showPoPayment(data) {
    this.commonVariableList.items = [];
  }
  showInvoicePayment(data) {
    this.commonVariableList.items = [];
    data.chequeList=data.chequeList?data.chequeList:[];
    this.commonVariableList.chequeList=data.chequeList;
  }
  showAdhocPayment(data) {
    this.commonVariableList.items = [];
    this.commonVariableList.is_goods=false;
    this.commonVariableList.adhoc_data={};
    if (data.adhoc_advance_payment_section_list) {
      let sl_no: number = 1;
      for (let i of data.adhoc_advance_payment_section_list) {
        i.extra_tds_deduction=parseFloat(this.webService.convertNaN(i.extra_tds_deduction))?parseFloat(this.webService.convertNaN(i.extra_tds_deduction)):'0'
        i.sl_no = sl_no; i.is_view = true; sl_no++;
      }
    }
    this.commonVariableList.sectionList=data.adhoc_advance_payment_section_list?data.adhoc_advance_payment_section_list:[];
    if(this.commonVariableList.extraGrandColumnList)
    {
      for(let i of this.commonVariableList.extraGrandColumnList)
      {
        if(i.value=='tds_rate')
        {
          i.display=this.adhoc_getColumnName('tds_rate','TDS Rate');
        }
        if(i.value=='tds_rate' && this.adhoc_is_column_visible('tds_rate',false))
        {
          i.is_view=true;
        }
        if(i.value=='tds_rate' && !this.adhoc_is_column_visible('tds_rate',false))
        {
          i.is_view=false;
        }

        if(i.value=='tds_section')
          {
            i.display=this.adhoc_getColumnName('tds_section','TDS Section');
          }
          if(i.value=='tds_section' && this.adhoc_is_column_visible('tds_section',false))
          {
            i.is_view=true;
          }
          if(i.value=='tds_section' && !this.adhoc_is_column_visible('tds_section',false))
          {
            i.is_view=false;
          }

          if(i.value=='po_amount_without_gst')
            {
              i.display=this.adhoc_getColumnName('po_amount_without_gst','PO Amount Without GST');
            }
            if(i.value=='po_amount_without_gst' && this.adhoc_is_column_visible('po_amount_without_gst',false))
            {
              i.is_view=true;
            }
            if(i.value=='po_amount_without_gst' && !this.adhoc_is_column_visible('po_amount_without_gst',false))
            {
              i.is_view=false;
            }

            if(i.value=='po_amount_with_gst')
              {
                i.display=this.adhoc_getColumnName('po_amount_with_gst','PO Amount With GST');
              }
              if(i.value=='po_amount_with_gst' && this.adhoc_is_column_visible('po_amount_with_gst',false))
              {
                i.is_view=true;
              }
              if(i.value=='po_amount_with_gst' && !this.adhoc_is_column_visible('po_amount_with_gst',false))
              {
                i.is_view=false;
              }

              if(i.value=='tds_deduction')
                {
                  i.display=this.adhoc_getColumnName('tds_deduction','TDS Deduction');
                }
                if(i.value=='tds_deduction' && this.adhoc_is_column_visible('tds_deduction',false))
                {
                  i.is_view=true;
                }
                if(i.value=='tds_deduction' && !this.adhoc_is_column_visible('tds_deduction',false))
                {
                  i.is_view=false;
                }
      }
    }
    this.commonVariableList.adhoc_data={'total_1':data.total_section_po_amount?data.total_section_po_amount:'','total_2':data.total_advance_amount?data.total_advance_amount:'','total_3':data.total_tds_deduction?data.total_tds_deduction:'','total_4':data.non_applicable_tds_amount?data.non_applicable_tds_amount:'0','total_5':data.net_payment?data.net_payment:'0'}
    this.commonVariableList.extraGrandColumnList=this.commonVariableList.extraGrandColumnList.filter((v)=>{return v.is_view});
    this.commonVariableList.extraItems = data.adhoc_advance_payment_section_list ? data.adhoc_advance_payment_section_list : [];
  }
  showsalesOrder(data) {
    this.commonVariableList.items = [];
  }
  showMyadvanceData(data) {
    this.commonVariableList.items = [];

  }
  showEmployeeAdvancePaymentData(data) {
    this.commonVariableList.items = [];

  }
  showSalesInvoice(data) {
    this.commonVariableList.items.push(
      { "title": 'Total Amount', "invoice_amount": data.total_invoice_amount, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": `Total ${this.company_setup.custom_sgst_name?this.company_setup.custom_sgst_name:'SGST'}`, "invoice_amount": data.total_invoice_sgst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_sgst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_cgst_name?this.company_setup.custom_cgst_name:'CGST' }`, "invoice_amount": data.total_invoice_cgst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_cgst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_igst_name?this.company_setup.custom_igst_name:'IGST'}`, "invoice_amount": data.total_invoice_igst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_igst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_ugst_name?this.company_setup.custom_ugst_name:'UGST'}`, "invoice_amount": data.total_invoice_ugst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_ugst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_cess_name?this.company_setup.custom_cess_name:'CESS'}`, "invoice_amount": data.total_invoice_cess, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_cess_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_other_tax_name?this.company_setup.custom_other_tax_name:'Other Tax'}`, "invoice_amount": data.total_invoice_other_tax, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_other_tax_visible == '1' ? true : false },
      { "title": 'Total GST', "invoice_amount": data.total_invoice_tax, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": 'Grand Total', "invoice_amount": data.grand_total_invoice_amount, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      // { "title": 'Other Charges', "invoice_amount": data.installation_charge,  "is_col_span":false,"col_span":'0',"is_view": true },
      // { "title": 'Freight Cost', "invoice_amount": data.freight_cost, "is_col_span":false,"col_span":'0',"is_view": true },
      // { "title": 'Discount Value', "invoice_amount": data.discount_value, "is_col_span":false,"col_span":'0',"is_view": true },
      // { "title": 'Adjusted Amount', "invoice_amount": data.adjusted_amount,  "is_col_span":false,"col_span":'0',"is_view": true },
      { "title": 'Total Payable', "invoice_amount": data.grand_total, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
    )
    this.makeData();

  }
  showProformaInvoice(data) {
    this.commonVariableList.items.push(
      { "title": 'Total Amount', "invoice_amount": data.total_invoice_amount, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": `Total ${this.company_setup.custom_sgst_name?this.company_setup.custom_sgst_name:'SGST'}`, "invoice_amount": data.total_invoice_sgst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_sgst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_cgst_name?this.company_setup.custom_cgst_name:'CGST'}`, "invoice_amount": data.total_invoice_cgst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_cgst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_igst_name?this.company_setup.custom_igst_name:'IGST'}`, "invoice_amount": data.total_invoice_igst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_igst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_ugst_name?this.company_setup.custom_ugst_name:'UGST'}`, "invoice_amount": data.total_invoice_ugst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_ugst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_cess_name?this.company_setup.custom_cess_name:'CESS'}`, "invoice_amount": data.total_invoice_cess, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_cess_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_other_tax_name?this.company_setup.custom_other_tax_name:'Other Tax'}`, "invoice_amount": data.total_invoice_other_tax, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_other_tax_visible == '1' ? true : false },
      { "title": 'Total GST', "invoice_amount": data.total_invoice_tax, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": 'Grand Total', "invoice_amount": data.grand_total_invoice_amount, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": 'Other Charges', "invoice_amount": data.installation_charge, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": 'Freight Cost', "invoice_amount": data.freight_cost, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": 'Discount Value', "invoice_amount": data.discount_value, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": 'Adjusted Amount', "invoice_amount": data.adjusted_amount, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": 'Total Payable', "invoice_amount": data.grand_total, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
    )
    this.makeData();

  }
  showSalesOrderData(data) {
    this.commonVariableList.items.push(
      { "title": 'Total Amount', "invoice_amount": data.total_invoice_amount, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": `Total ${this.company_setup.custom_sgst_name?this.company_setup.custom_sgst_name:'SGST'}`, "invoice_amount": data.total_invoice_sgst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_sgst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_cgst_name?this.company_setup.custom_cgst_name:'CGST'}`, "invoice_amount": data.total_invoice_cgst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_cgst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_igst_name?this.company_setup.custom_igst_name:'IGST'}`, "invoice_amount": data.total_invoice_igst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_igst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_ugst_name?this.company_setup.custom_ugst_name:'UGST'}`, "invoice_amount": data.total_invoice_ugst, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_ugst_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_cess_name?this.company_setup.custom_cess_name:'CESS'}`, "invoice_amount": data.total_invoice_cess, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_cess_visible == '1' ? true : false },
      { "title": `Total ${this.company_setup.custom_other_tax_name?this.company_setup.custom_other_tax_name:'Other Tax'}`, "invoice_amount": data.total_invoice_other_tax, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_other_tax_visible == '1' ? true : false },
      { "title": 'Total GST', "invoice_amount": data.total_invoice_tax, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": 'Grand Total', "invoice_amount": data.grand_total_invoice_amount, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      // { "title": 'Other Charges', "invoice_amount": data.installation_charge,  "is_col_span":false,"col_span":'0',"is_view": true },
      // { "title": 'Freight Cost', "invoice_amount": data.freight_cost, "is_col_span":false,"col_span":'0',"is_view": true },
      // { "title": 'Discount Value', "invoice_amount": data.discount_value, "is_col_span":false,"col_span":'0',"is_view": true },
      // { "title": 'Adjusted Amount', "invoice_amount": data.adjusted_amount,  "is_col_span":false,"col_span":'0',"is_view": true },
      { "title": 'Total Payable', "invoice_amount": data.grand_total, "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
    )
    // this.commonVariableList.totalList.is_view=true;
    // this.commonVariableList.totalList.title='Total Amount';
    this.makeData();

  }
  showStn(data) { }
  showPr(data) {
    data.grand_total = this.webService.convertNaN(data.grand_total)
    data.total_qty = this.webService.convertNaN(data.total_qty)

    this.showAvailableBudget = (this.tableDetails.showAvailableBudget && this.tableDetails.showAvailableBudget == "0") ? false: true;
    this.showAmounts = (this.tableDetails.showAmounts && this.tableDetails.showAmounts == "0") ? false: true;

    this.commonVariableList.items.push(
      { "title": 'Total Qty', "amount": data.total_qty ? data.total_qty : '', "foreign_amount": data.total_qty ? data.total_qty : '', "is_col_span": false, "col_span": '0',is_ddc_view:data.is_different_document_currency=='1', "is_view": (this.company_setup.tot_qty_visible_in_pr == '1')? true : false,'is_currency':false },
      { "title": 'Grand Total', "amount": data.grand_total ? data.grand_total : '', "foreign_amount": data.ddc_grand_total ? data.ddc_grand_total : '', "is_col_span": false, "col_span": '0',is_ddc_view:data.is_different_document_currency=='1', "is_view": (this.company_setup.grand_tot_visible_in_pr == '1' && this.showAmounts)? true : false,'is_currency':true },
    )
    this.commonVariableList.items=this.commonVariableList.items.filter((v)=>{return v.is_view})
   }
  showIr(data) {
    if (this.company_setup.grand_tot_visible_in_ir != '1') {
      return;
    }
    data.grand_total = this.webService.convertNaN(data.grand_total);
    data.total_qty = this.webService.convertNaN(data.total_qty);
    this.commonVariableList.items.push(
      {
        title: this.irFields.getIrFieldDisplayName(this.company_setup, 'total_qty', 'Total Qty'),
        amount: data.total_qty ? data.total_qty : '',
        foreign_amount: data.total_qty ? data.total_qty : '',
        is_col_span: false,
        col_span: '0',
        is_ddc_view: false,
        is_view: true,
        is_currency: false,
      },
      {
        title: this.irFields.getIrFieldDisplayName(this.company_setup, 'grand_total', 'Grand Total'),
        amount: data.grand_total ? data.grand_total : '',
        foreign_amount: data.grand_total ? data.grand_total : '',
        is_col_span: false,
        col_span: '0',
        is_ddc_view: false,
        is_view: true,
        is_currency: true,
      }
    );
  }
  showIRHistory(data) {
    this.showIr(data);
  }
  showMpr(data) {
    if (Array.isArray(data.boq_list)) {
      this.commonVariableList.is_mpr_boq = data.boq_list.length > 0 ? true : false;
      this.commonVariableList.boqList = [];
      this.commonVariableList.boqList = data.boq_list ? data.boq_list : [];
    }
  }
  showLogistiics(data) { }

  showMp(data) { }
  showSi(data) { }
  formatWithCompanyDecimal(value, context) {
    const decimalPlaces = 2; // default to 2 if undefined
    return value != null && !isNaN(value)
      ? Number(value).toFixed(decimalPlaces)
      : '';
  }
  diff_json_data = {};
  // old_json_data = {};
  show_difference : boolean = false;
  showPo(data) {
    this.company_setup.discount_type_in_po = data.discount_type_in_po ? data.discount_type_in_po : this.company_setup.discount_type_in_po;
    this.stillLoading = true;
    this.diff_json_data = this.tableDetails.diff_json_data ? this.tableDetails.diff_json_data : {};
    this.show_difference = this.tableDetails.show_difference && this.tableDetails.show_difference=='1' ? true : false;
    let old_json_data = this.tableDetails.old_json_data ? this.tableDetails.old_json_data : {};
    // console.log("old_json_data", old_json_data)
    this.commonVariableList.fields = data;
    let advance_amount_percentage:any=this.webService.convertNaN(data.advance_amount_percentage)
    data.advanceamount = Number(this.webService.convertNaN(data.advanceamount)).toFixed(2);
    data.advance_amount_percentage = Number(this.webService.convertNaN(data.advance_amount_percentage)).toFixed(2);

data.total = Number(this.webService.convertNaN(data.total)).toFixed(2);
data.discount_amount = Number(this.webService.convertNaN(data.discount_amount)).toFixed(2);
data.total_quantity_amount = Number(this.webService.convertNaN(data.total_quantity_amount)).toFixed(2);
data.totalSgst = Number(this.webService.convertNaN(data.totalSgst)).toFixed(2);
data.totalCgst = Number(this.webService.convertNaN(data.totalCgst)).toFixed(2);
data.totalIgst = Number(this.webService.convertNaN(data.totalIgst)).toFixed(2);
data.totalUgst = Number(this.webService.convertNaN(data.totalUgst)).toFixed(2);
data.totalCess = Number(this.webService.convertNaN(data.totalCess)).toFixed(2);
data.totalOtherTax = Number(this.webService.convertNaN(data.totalOtherTax)).toFixed(2);
data.discounted_amount = Number(this.webService.convertNaN(data.discounted_amount)).toFixed(2);
data.totalTax = Number(this.webService.convertNaN(data.totalTax)).toFixed(2);
data.grandTotal = Number(this.webService.convertNaN(data.grandTotal)).toFixed(2);

    data.advanceamount = parseFloat(data.advanceamount)
    data.total = parseFloat(data.total)
    data.discount_amount = parseFloat(data.discount_amount)
    data.discounted_amount = parseFloat(data.discounted_amount)
    data.total_quantity_amount = parseFloat(data.total_quantity_amount)
    data.totalSgst = parseFloat(data.totalSgst)
    data.totalSgst = parseFloat(data.totalSgst)
    data.totalIgst = parseFloat(data.totalIgst)
    data.totalUgst = parseFloat(data.totalUgst)
    data.totalCess = parseFloat(data.totalCess)
    data.totalOtherTax = parseFloat(data.totalOtherTax)
    data.totalTax = parseFloat(data.totalTax)
    data.grandTotal = parseFloat(data.grandTotal)


    data.automatic_advance_request = data.automatic_advance_request ? data.automatic_advance_request : "0"

    this.advPaymentPoSavedAttachments = data.advPaymentPoSavedAttachments ? this.webService.makeAttachment(data.advPaymentPoSavedAttachments) : []
    this.vendorDocuments = data.vendorDocuments ? this.webService.makeAttachment(data.vendorDocuments) : []
    data.advanceamount = Number(this.webService.convertNaN(data.advanceamount)).toFixed(2);
    data.total = Number(this.webService.convertNaN(data.total)).toFixed(2);
    data.total_quantity_amount = Number(this.webService.convertNaN(data.total_quantity_amount)).toFixed(2);
    data.totalSgst = Number(this.webService.convertNaN(data.totalSgst)).toFixed(2);
    data.totalCgst = Number(this.webService.convertNaN(data.totalCgst)).toFixed(2);
    data.totalIgst = Number(this.webService.convertNaN(data.totalIgst)).toFixed(2);
    data.totalUgst = Number(this.webService.convertNaN(data.totalUgst)).toFixed(2);
    data.totalCess = Number(this.webService.convertNaN(data.totalCess)).toFixed(2);
    data.totalOtherTax = Number(this.webService.convertNaN(data.totalOtherTax)).toFixed(2);
    data.discounted_amount = Number(this.webService.convertNaN(data.discounted_amount)).toFixed(2);
    data.discount_amount = Number(this.webService.convertNaN(data.discount_amount)).toFixed(2);
    data.totalTax = Number(this.webService.convertNaN(data.totalTax)).toFixed(2);
    data.grandTotal = Number(this.webService.convertNaN(data.grandTotal)).toFixed(2);
    
    // Foreign Amounts
    data.total_foreign_amount = Number(this.webService.convertNaN(data.total_foreign_amount)).toFixed(2);
    data.discounted_foreign_amount = Number(this.webService.convertNaN(data.discounted_foreign_amount)).toFixed(2);
    data.discount_foreign_total = Number(this.webService.convertNaN(data.discount_foreign_total)).toFixed(2);
    data.total_foreign_quantity_amount = Number(this.webService.convertNaN(data.total_foreign_quantity_amount)).toFixed(2);
    data.foreign_final_total = Number(this.webService.convertNaN(data.foreign_final_total)).toFixed(2);
    

    if(data.is_different_document_currency == true){
      data.total_advance_foreign_amount = (data.advanceamount && data.conversion_rate) ? this.webService.convertNaN(data.advanceamount / data.conversion_rate) : '';
      // data.total_advance_foreign_percentange = (data.advance_amount_percentage && data.conversion_rate) ? this.webService.convertNaN(data.advance_amount_percentage / data.conversion_rate) : '';
      data.total_advance_foreign_percentange = data.advance_amount_percentage ? data.advance_amount_percentage : '';
    }else{
      data.total_advance_foreign_amount = data.advanceamount ?  data.advanceamount : '';
      data.total_advance_foreign_percentange = data.advance_amount_percentage ? data.advance_amount_percentage : '';
    }
    // data.chequeList=data.chequeList?data.chequeList:[];
    // this.commonVariableList.chequeList=data.chequeList;
    let is_different_document_currency = false;
    // if(this.commonVariableList.fields.is_different_document_currency == Boolean) {
    //   is_different_document_currency = this.commonVariableList.fields.is_different_document_currency;
    // } else {
    //   is_different_document_currency = this.commonVariableList.fields.is_different_document_currency == '1' ? true : false;
    // }
    if (typeof this.commonVariableList.fields.is_different_document_currency === 'boolean') {
      is_different_document_currency = this.commonVariableList.fields.is_different_document_currency;
    } else {
      is_different_document_currency = this.commonVariableList.fields.is_different_document_currency == '1' ? true : false;
    }
    this.DiscountAmount = this.company_setup.discount_type_in_po == '0' || this.company_setup.discount_type_in_po == 'none' ? false  : true;
    if(this.company_setup.gst_fields_not_shown_when_value_is_zero == '1'){
      this.CgstVisible = data.totalCgst ?  data.totalCgst>0 : false;
      this.SgstVisible = data.totalSgst ?  data.totalSgst>0 : false;
      this.IgstVisible = data.totalIgst ?  data.totalIgst>0 : false;
      this.UgstVisible = data.totalUgst ?  data.totalUgst>0 : false;
      this.CessVisible = data.totalCess ?  data.totalCess>0 : false;
      this.OthertaxVisible = data.totalOtherTax ?  data.totalOtherTax>0 : false;
      this.TotaltaxVisible = data.totalTax ?  data.totalTax>0 : false;
      } else if(is_different_document_currency){
        this.DiscountAmount = this.company_setup.discount_type_in_po == '0' || this.company_setup.discount_type_in_po == 'none' ? false  : true;
      this.CgstVisible =  false;
      this.SgstVisible = false;
      this.IgstVisible =  false;
      this.UgstVisible =  false;
      this.CessVisible = false;
      this.OthertaxVisible = false;
      this.TotaltaxVisible = false;
      } else {
        this.DiscountAmount = this.company_setup.discount_type_in_po == '0' || this.company_setup.discount_type_in_po == 'none' ? false  : true;
        this.CgstVisible = true;
        this.SgstVisible = true;
        this.IgstVisible = true;
        this.UgstVisible = true;
        this.CessVisible = true;
        this.OthertaxVisible = true;
        this.TotaltaxVisible = true;
      }
      if(data.is_different_document_currency == 1){
      this.foreign_round_grandTotal = parseFloat(this.webService.convertNaN(data.round_grandTotal))/parseFloat(this.webService.convertNaN(data.conversion_rate))
      this.foreign_final_total_roundoff = parseFloat(this.webService.convertNaN(data.foreign_final_total))+parseFloat(this.webService.convertNaN(this.foreign_round_grandTotal))
    }
    data.advance_amount_percentage = data.advance_amount_percentage
    ? Number(this.webService.convertNaN(data.advance_amount_percentage)).toFixed(2)
    : '0.00';
  
  data.round_grandTotal = data.round_grandTotal
    ? Number(this.webService.convertNaN(data.round_grandTotal)).toFixed(2)
    : '0.00';
  
  data.roundedOff_grandTotal = data.roundedOff_grandTotal
    ? Number(this.webService.convertNaN(data.roundedOff_grandTotal)).toFixed(2)
    : '0.00';
    data.roundedOff_grandTotal = data.roundedOff_grandTotal
    ? Number(this.webService.convertNaN(data.roundedOff_grandTotal)).toFixed(2)
    : '0.00';
  
    let type : any = '';
    let amount:any = data.grandTotal
    if(data.advanceamount)
    {
      type = 'percent';
    } else if(parseFloat(data.advance_amount_percentage) == 0) {
      data.advanceAmountPercentage = data.advance_amount_percentage;
      data.percentage_on_without_gst = data.advance_amount_percentage;
    }
    
    if(this.company_setup.is_discount_applicable_in_po=='1')
    {
      amount = data.discounted_amount
    }

    if(this.company_setup.is_discount_applicable_in_po!='1' && this.company_setup.in_po_gst_will_calculate_on=='without_gst')
    {
      amount = data.Total
    }
    if(type=='percent')
    {
      data.advanceAmountPercentage=0;
      data.percentage_on_without_gst=0;
  
      if(parseFloat(data.advanceamount)>0 && parseFloat(data.grandTotal)>0)
      {
        if(this.company_setup.in_po_gst_will_calculate_on=='with_gst')
        {
          data.advanceAmountPercentage=(parseFloat(data.advanceamount)/parseFloat(data.grandTotal))*100
        }
        else
        {
          data.advanceAmountPercentage=(parseFloat(data.advanceamount)/parseFloat(amount))*100
        }
        data.advanceAmountPercentage = parseFloat(Number(this.webService.convertNaN(data.advanceAmountPercentage)).toFixed(2)); // returns 16.2 but rounded properly
        data.advanceAmountPercentage = data.advanceAmountPercentage
        ? Number(this.webService.convertNaN(data.advanceAmountPercentage)).toFixed(2)
        : '0.00';
        data.percentage_on_without_gst=(parseFloat(data.advanceAmount)/parseFloat(data.total_quantity_amount))*100
        data.percentage_on_without_gst=this.webService.convertNaN(data.percentage_on_without_gst);
  
      }
      else {
        data.advanceAmountPercentage = this.formatWithCompanyDecimal(0, this);
        data.percentage_on_without_gst = this.formatWithCompanyDecimal(0, this);
      }
    }
    this.commonVariableList.items.push(

      { "title": 'Advance Amount', "amount": data.advanceamount ? data.advanceamount : '', "foreign_amount": data.total_advance_foreign_amount ? data.total_advance_foreign_amount : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.is_advance_amt_visible_in_add_direct_po == '1'? true : false },
      { "title": 'Advance Amount Percentage %', "amount": data.advanceAmountPercentage ? data.advanceAmountPercentage : '', "foreign_amount": data.advance_amount_percentage ? data.advance_amount_percentage : '', "is_col_span": false, "col_span": '0', "is_view":this.company_setup.is_advance_amt_percentage_visible_in_add_direct_po == '1'? true : false,'is_currency':false },

      { "title": 'Total Amount', "amount": data.total ? data.total : '', "foreign_amount": data.total_foreign_amount ? data.total_foreign_amount : '', "is_col_span": false, "col_span": '0', "is_view": true },
      { "title": 'Discount Amount', "amount": data.discount_amount ? data.discount_amount : '', "foreign_amount": parseFloat(this.webService.convertNaN(data.discount_amount))>0?((data.discount_foreign_total ? data.discount_foreign_total : '')):'', "is_col_span": false, "col_span": '0', "is_view": this.company_setup.is_discount_applicable_in_po == '1' && this.DiscountAmount},
      // { "title": this.company_setup.custome_name_for_total_discounted_amount_in_po_module, "amount": data.discounted_amount ? data.discounted_amount : '', "foreign_amount": parseFloat(this.webService.convertNaN(data.discount_amount))>0?(data.discounted_foreign_amount ? data.discounted_foreign_amount : ''):'', "is_col_span": false, "col_span": '0', "is_view": this.company_setup.is_discount_applicable_in_po == '1' ? true : false },
      { "title": this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'discounted_amount','Total Discounted Amount').custom_title, "amount": data.discounted_amount ? data.discounted_amount : '', "foreign_amount": parseFloat(this.webService.convertNaN(data.discount_amount))>0?(data.discounted_foreign_amount ? data.discounted_foreign_amount : ''):'', "is_col_span": false, "col_span": '0', "is_view": this.company_setup.is_discount_applicable_in_po == '1' && this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'discounted_amount',true).is_visible && this.DiscountAmount},

      // { "title": 'Total Quantity Amount', "amount": data.total_quantity_amount ? data.total_quantity_amount : '', "foreign_amount": data.total_foreign_quantity_amount ? data.total_foreign_quantity_amount : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": `Total ${this.company_setup.custom_cgst_name?this.company_setup.custom_cgst_name:'CGST'}`, "amount": data.totalCgst ? data.totalCgst : '', "foreign_amount": data.is_ddc_totalCgst ? data.is_ddc_totalCgst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_cgst_visible == '1' && this.CgstVisible },
      { "title": `Total ${this.company_setup.custom_sgst_name?this.company_setup.custom_sgst_name:'SGST'}`, "amount": data.totalSgst ? data.totalSgst : '', "foreign_amount": data.is_ddc_totalSgst ? data.is_ddc_totalSgst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_sgst_visible == '1' && this.SgstVisible},
      { "title": `Total ${this.company_setup.custom_igst_name?this.company_setup.custom_igst_name:'IGST'}`, "amount": data.totalIgst ? data.totalIgst : '', "foreign_amount": data.is_ddc_totalIgst ? data.is_ddc_totalIgst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_igst_visible == '1' && this.IgstVisible},
      { "title": `Total ${this.company_setup.custom_ugst_name?this.company_setup.custom_ugst_name:'UGST'}`, "amount": data.totalUgst ? data.totalUgst : '', "foreign_amount": data.is_ddc_totalUgst ? data.is_ddc_totalUgst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_ugst_visible == '1' && this.UgstVisible},
      { "title": `Total ${this.company_setup.custom_cess_name?this.company_setup.custom_cess_name:'CESS'}`, "amount": data.totalCess ? data.totalCess : '', "foreign_amount": data.is_ddc_totalCess ? data.is_ddc_totalCess : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_cess_visible == '1' && this.CessVisible},
      { "title": `Total ${this.company_setup.custom_other_tax_name?this.company_setup.custom_other_tax_name:'Other Tax'}`, "amount": data.totalOtherTax ? data.totalOtherTax : '', "foreign_amount": data.is_ddc_totalOtherTax ? data.is_ddc_totalOtherTax : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_other_tax_visible == '1' && this.OthertaxVisible},
      { "title": 'Total Tax', "amount": data.totalTax ? data.totalTax : '', "foreign_amount": data.is_ddc_totalGst ? data.is_ddc_totalGst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_total_gst_visible == '1' && this.TotaltaxVisible},
      { "title": 'Grand Total', "amount": data.grandTotal ? data.grandTotal : '0', "foreign_amount": data.foreign_final_total ? data.foreign_final_total : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'round_grandTotal','Round Off').custom_title, "amount": data.round_grandTotal ? data.round_grandTotal : '0', "foreign_amount": this.foreign_round_grandTotal ? this.foreign_round_grandTotal : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'round_grandTotal',true).is_visible},
      { "title": this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'roundedOff_grandTotal','Total Payable Rounded Off').custom_title, "amount": data.roundedOff_grandTotal ? data.roundedOff_grandTotal : '0', "foreign_amount": this.foreign_final_total_roundoff ? this.foreign_final_total_roundoff : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view":  this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'roundedOff_grandTotal',true).is_visible},
      {
        "title": 'Total Landed Cost',
        "amount": this.getTotalLandedCost(),
        "foreign_amount": this.getTotalLandedCostForeign(),
        "is_col_span": false,
        "col_span": '0',
        "is_ddc_view": false,
        "is_view": this.isAllocableCostEnabled() && this.company_setup && this.company_setup.enable_allocable_cost_direct_po == '1'
      },


    )
    if(this.show_difference) {
      this.company_setup.discount_type_in_po = old_json_data.discount_type_in_po ? old_json_data.discount_type_in_po : this.company_setup.discount_type_in_po;
      old_json_data.advanceamount = Number(this.webService.convertNaN(old_json_data.advanceamount)).toFixed(2);
old_json_data.total = Number(this.webService.convertNaN(old_json_data.total)).toFixed(2);
old_json_data.discount_amount = Number(this.webService.convertNaN(old_json_data.discount_amount)).toFixed(2);
old_json_data.discounted_amount = Number(this.webService.convertNaN(old_json_data.discounted_amount)).toFixed(2);
old_json_data.total_quantity_amount = Number(this.webService.convertNaN(old_json_data.total_quantity_amount)).toFixed(2);
old_json_data.totalSgst = Number(this.webService.convertNaN(old_json_data.totalSgst)).toFixed(2);
old_json_data.totalIgst = Number(this.webService.convertNaN(old_json_data.totalIgst)).toFixed(2);
old_json_data.totalUgst = Number(this.webService.convertNaN(old_json_data.totalUgst)).toFixed(2);
old_json_data.totalCess = Number(this.webService.convertNaN(old_json_data.totalCess)).toFixed(2);
old_json_data.totalOtherTax = Number(this.webService.convertNaN(old_json_data.totalOtherTax)).toFixed(2);
old_json_data.totalTax = Number(this.webService.convertNaN(old_json_data.totalTax)).toFixed(2);
old_json_data.grandTotal = Number(this.webService.convertNaN(old_json_data.grandTotal)).toFixed(2);


      old_json_data.advanceamount = parseFloat(old_json_data.advanceamount)
      old_json_data.total = parseFloat(old_json_data.total)
      old_json_data.discount_amount = parseFloat(old_json_data.discount_amount)
      old_json_data.discounted_amount = parseFloat(old_json_data.discounted_amount)
      old_json_data.total_quantity_amount = parseFloat(old_json_data.total_quantity_amount)
      old_json_data.totalSgst = parseFloat(old_json_data.totalSgst)
      old_json_data.totalSgst = parseFloat(old_json_data.totalSgst)
      old_json_data.totalIgst = parseFloat(old_json_data.totalIgst)
      old_json_data.totalUgst = parseFloat(old_json_data.totalUgst)
      old_json_data.totalCess = parseFloat(old_json_data.totalCess)
      old_json_data.totalOtherTax = parseFloat(old_json_data.totalOtherTax)
      old_json_data.totalTax = parseFloat(old_json_data.totalTax)
      old_json_data.grandTotal = parseFloat(old_json_data.grandTotal)



      // Standard Amounts
old_json_data.advanceamount = Number(this.webService.convertNaN(old_json_data.advanceamount)).toFixed(2);
old_json_data.total = Number(this.webService.convertNaN(old_json_data.total)).toFixed(2);
old_json_data.discounted_amount = Number(this.webService.convertNaN(old_json_data.discounted_amount)).toFixed(2);
old_json_data.discount_amount = Number(this.webService.convertNaN(old_json_data.discount_amount)).toFixed(2);
old_json_data.total_quantity_amount = Number(this.webService.convertNaN(old_json_data.total_quantity_amount)).toFixed(2);
old_json_data.totalSgst = Number(this.webService.convertNaN(old_json_data.totalSgst)).toFixed(2);
old_json_data.totalIgst = Number(this.webService.convertNaN(old_json_data.totalIgst)).toFixed(2);
old_json_data.totalUgst = Number(this.webService.convertNaN(old_json_data.totalUgst)).toFixed(2);
old_json_data.totalCess = Number(this.webService.convertNaN(old_json_data.totalCess)).toFixed(2);
old_json_data.totalOtherTax = Number(this.webService.convertNaN(old_json_data.totalOtherTax)).toFixed(2);
old_json_data.totalTax = Number(this.webService.convertNaN(old_json_data.totalTax)).toFixed(2);
old_json_data.grandTotal = Number(this.webService.convertNaN(old_json_data.grandTotal)).toFixed(2);

// Percentages / Optional Numbers
old_json_data.advance_amount_percentage = old_json_data.advance_amount_percentage
  ? Number(this.webService.convertNaN(old_json_data.advance_amount_percentage)).toFixed(2)
  : "";
old_json_data.round_grandTotal = Number(this.webService.convertNaN(old_json_data.round_grandTotal)).toFixed(2);
old_json_data.roundedOff_grandTotal = Number(this.webService.convertNaN(old_json_data.roundedOff_grandTotal)).toFixed(2);

// Foreign Amounts
old_json_data.total_foreign_amount = Number(this.webService.convertNaN(old_json_data.total_foreign_amount)).toFixed(2);
old_json_data.discounted_foreign_amount = Number(this.webService.convertNaN(old_json_data.discounted_foreign_amount)).toFixed(2);
old_json_data.discount_foreign_total = Number(this.webService.convertNaN(old_json_data.discount_foreign_total)).toFixed(2);
old_json_data.total_foreign_quantity_amount = Number(this.webService.convertNaN(old_json_data.total_foreign_quantity_amount)).toFixed(2);
old_json_data.foreign_final_total = Number(this.webService.convertNaN(old_json_data.foreign_final_total)).toFixed(2);

      // old_json_data.chequeList=old_json_data.chequeList?old_json_data.chequeList:[];
      // this.commonVariableList.chequeList=old_json_data.chequeList;
      if(this.company_setup.gst_fields_not_shown_when_value_is_zero == '1'){
        this.DiscountAmount = this.company_setup.discount_type_in_po == '0' || this.company_setup.discount_type_in_po == 'none' ? false  : true;
        this.CgstVisible = old_json_data.totalCgst ?  old_json_data.totalCgst>0 : false;
        this.SgstVisible = old_json_data.totalSgst ?  old_json_data.totalSgst>0 : false;
        this.IgstVisible = old_json_data.totalIgst ?  old_json_data.totalIgst>0 : false;
        this.UgstVisible = old_json_data.totalUgst ?  old_json_data.totalUgst>0 : false;
        this.CessVisible = old_json_data.totalCess ?  old_json_data.totalCess>0 : false;
        this.OthertaxVisible = old_json_data.totalOtherTax ?  old_json_data.totalOtherTax>0 : false;
        this.TotaltaxVisible = old_json_data.totalTax ?  old_json_data.totalTax>0 : false;
        } else if(this.commonVariableList.fields.is_different_document_currency){
        this.CgstVisible =  false;
        this.SgstVisible = false;
        this.IgstVisible =  false;
        this.UgstVisible =  false;
        this.CessVisible = false;
        this.OthertaxVisible = false;
        this.TotaltaxVisible = false;
        } else {
          this.DiscountAmount = this.company_setup.discount_type_in_po == '0' || this.company_setup.discount_type_in_po == 'none' ? false  : true;
          this.CgstVisible = true;
          this.SgstVisible = true;
          this.IgstVisible = true;
          this.UgstVisible = true;
          this.CessVisible = true;
          this.OthertaxVisible = true;
          this.TotaltaxVisible = true;
        }
        if(old_json_data.is_different_document_currency == 1){
        this.foreign_round_grandTotal = parseFloat(this.webService.convertNaN(old_json_data.round_grandTotal))/parseFloat(this.webService.convertNaN(old_json_data.conversion_rate))
        this.foreign_final_total_roundoff = parseFloat(this.webService.convertNaN(old_json_data.foreign_final_total))+parseFloat(this.webService.convertNaN(this.foreign_round_grandTotal))
      }

      this.commonVariableList.diff_items.push(
        { "title": 'Advance Amount', "amount": old_json_data.advanceamount ? old_json_data.advanceamount : '', "foreign_amount": old_json_data.advanceamount ? old_json_data.advanceamount : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.is_advance_amt_visible_in_add_direct_po == '1'? true : false },
        { "title": 'Advance Amount Percentage %', "amount": old_json_data.advance_amount_percentage ? old_json_data.advance_amount_percentage : '', "is_col_span": false, "col_span": '0', "is_view":this.company_setup.is_advance_amt_percentage_visible_in_add_direct_po == '1'? true : false,'is_currency':false },

        { "title": 'Total Amount', "amount": old_json_data.total ? old_json_data.total : '', "foreign_amount": old_json_data.total_foreign_amount ? old_json_data.total_foreign_amount : '', "is_col_span": false, "col_span": '0', "is_view": true },
        { "title": 'Discount Amount', "amount": old_json_data.discount_amount ? old_json_data.discount_amount : '', "foreign_amount": parseFloat(this.webService.convertNaN(old_json_data.discount_amount))>0?((old_json_data.discount_foreign_total ? old_json_data.discount_foreign_total : '')):'', "is_col_span": false, "col_span": '0', "is_view": this.company_setup.is_discount_applicable_in_po == '1' && this.DiscountAmount},
        // { "title": this.company_setup.custome_name_for_total_discounted_amount_in_po_module, "amount": old_json_data.discounted_amount ? old_json_data.discounted_amount : '', "foreign_amount": parseFloat(this.webService.convertNaN(old_json_data.discount_amount))>0?(old_json_data.discounted_foreign_amount ? old_json_data.discounted_foreign_amount : ''):'', "is_col_span": false, "col_span": '0', "is_view": this.company_setup.is_discount_applicable_in_po == '1' ? true : false },
        { "title": this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'discounted_amount','Total Discounted Amount').custom_title, "amount": old_json_data.discounted_amount ? old_json_data.discounted_amount : '', "foreign_amount": parseFloat(this.webService.convertNaN(old_json_data.discount_amount))>0?(old_json_data.discounted_foreign_amount ? old_json_data.discounted_foreign_amount : ''):'', "is_col_span": false, "col_span": '0', "is_view": this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'discounted_amount',true).is_visible && this.DiscountAmount},

        // { "title": 'Total Quantity Amount', "amount": old_json_data.total_quantity_amount ? old_json_data.total_quantity_amount : '', "foreign_amount": old_json_data.total_foreign_quantity_amount ? old_json_data.total_foreign_quantity_amount : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
        { "title": `Total ${this.company_setup.custom_cgst_name?this.company_setup.custom_cgst_name:'CGST'}`, "amount": old_json_data.totalCgst ? old_json_data.totalCgst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_cgst_visible == '1' && this.CgstVisible },
        { "title": `Total ${this.company_setup.custom_sgst_name?this.company_setup.custom_sgst_name:'SGST'}`, "amount": old_json_data.totalSgst ? old_json_data.totalSgst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_sgst_visible == '1' && this.SgstVisible},
        { "title": `Total ${this.company_setup.custom_igst_name?this.company_setup.custom_igst_name:'IGST'}`, "amount": old_json_data.totalIgst ? old_json_data.totalIgst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_igst_visible == '1' && this.IgstVisible},
        { "title": `Total ${this.company_setup.custom_ugst_name?this.company_setup.custom_ugst_name:'UGST'}`, "amount": old_json_data.totalUgst ? old_json_data.totalUgst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_ugst_visible == '1' && this.UgstVisible},
        { "title": `Total ${this.company_setup.custom_cess_name?this.company_setup.custom_cess_name:'CESS'}`, "amount": old_json_data.totalCess ? old_json_data.totalCess : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_cess_visible == '1' && this.CessVisible},
        { "title": `Total ${this.company_setup.custom_other_tax_name?this.company_setup.custom_other_tax_name:'Other Tax'}`, "amount": old_json_data.totalOtherTax ? old_json_data.totalOtherTax : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_other_tax_visible == '1' && this.OthertaxVisible},
        { "title": 'Total Tax', "amount": old_json_data.totalTax ? old_json_data.totalTax : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.company_setup.custom_total_gst_visible == '1' && this.TotaltaxVisible},
        { "title": 'Grand Total', "amount": old_json_data.grandTotal ? old_json_data.grandTotal : '0', "foreign_amount": old_json_data.foreign_final_total ? old_json_data.foreign_final_total : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
        { "title": this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'round_grandTotal','Round Off').custom_title, "amount": old_json_data.round_grandTotal ? old_json_data.round_grandTotal : '0', "foreign_amount": this.foreign_round_grandTotal ? this.foreign_round_grandTotal : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'round_grandTotal',true).is_visible},
        { "title": this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'roundedOff_grandTotal','Total Payable Rounded Off').custom_title, "amount": old_json_data.roundedOff_grandTotal ? old_json_data.roundedOff_grandTotal : '0', "foreign_amount": this.foreign_final_total_roundoff ? this.foreign_final_total_roundoff : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": this.webService.returnData(this.company_setup.po_summary_title.main_title_1_columns,'roundedOff_grandTotal',true).is_visible },
        {
          "title": 'Total Landed Cost',
          "amount": this.getTotalLandedCost(),
          "foreign_amount": this.getTotalLandedCostForeign(),
          "is_col_span": false,
          "col_span": '0',
          is_ddc_view:false,
          "is_view": this.isAllocableCostEnabled() && this.company_setup && this.company_setup.enable_allocable_cost_direct_po == '1'
        },


      )
    }

    this.commonVariableList.extra_data_list.title='PO Annexure List';
    this.commonVariableList.extra_data_list.items=data.annexure_list?data.annexure_list:[];

    if(this.company_setup.is_upload_annexure_button_visible_in_po=='1')
    {
        if (this.commonVariableList.extra_data_list.columnList) {

          for (let i:number=0;i<this.commonVariableList.extra_data_list.columnList.length;i++) {

          this.commonVariableList.extra_data_list.columnList[i].display=this.company_setup.po_annexure_template_for_upload[i].custom_name ? this.company_setup.po_annexure_template_for_upload[i].custom_name:'Field '+(i+1);
      }
    }

  }
  this.stillLoading = false;
  this.makeData();
  }
  showIrn(data) {
    this.commonVariableList.items = [];
    this.commonVariableList.totalList = {};
    this.commonVariableList.extraItems = [];
  this.commonVariableList.irn_grn_other_info=[];
    this.commonVariableList.acceptedList = data.acceptedList ? data.acceptedList : [];
    this.commonVariableList.rejectedList = data.rejectedList ? data.rejectedList : [];
    this.commonVariableList.irn_grn_other_info=[];
    this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : "2";
    this.company_setup.questionnaire_upload_table_in_irn = this.company_setup.questionnaire_upload_table_in_irn ? this.company_setup.questionnaire_upload_table_in_irn : [];


    if(this.commonVariableList.acceptedList)
    {
      for(let i of this.commonVariableList.acceptedList)
      {
        i.quantity=this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);
        i.quantity=parseFloat(i.quantity);
        i.quantity=this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);

      }
    }
    if(this.commonVariableList.rejectedList)
    {
      for(let i of this.commonVariableList.rejectedList)
      {
        i.quantity=this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);
        i.quantity=parseFloat(i.quantity);
        i.quantity=this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);

      }
    }

    let keys:any=[];
     data.irn_other_info=data.irn_other_info?data.irn_other_info:[];
     if(data.irn_other_info.length>0)
    {
      for(var i in data.irn_other_info){
        var key = i;
        var val = data.irn_other_info[i];
        //  //console.log(val);
        let key_list:any={};
        let columns=[];
        for(var j in val){
            var sub_key = j;
            var sub_val = val[j];
            // keys.push({'columns':{'key':sub_val,'id':sub_key}});
            key_list.id=sub_key;
            key_list.key=sub_val;
            columns.push({'id':sub_key,'key':sub_val});
        }
        keys.push({"columns":columns});
    }
        data.irn_other_info=[];
        data.irn_other_info=keys?keys:[];
        this.commonVariableList.irn_grn_other_info=data.irn_other_info?data.irn_other_info:[];
        this.commonVariableList.irn_grn_other_info_total_row={
          actual_weight_total:data.actual_weight_total?data.actual_weight_total:'',
          volumetric_weight_total:data.volumetric_weight_total?data.volumetric_weight_total:'',
          chargeable_weight_total:data.chargeable_weight_total?data.chargeable_weight_total:'',
        }
    }
    
    this.commonVariableList.multi_attachments = data.multi_attachments ? data.multi_attachments : [];
    if(this.company_setup.questionnaire_upload_table_in_irn.length==0) {
      this.commonVariableList.multi_attachments = [];
    } else {
      for(let i of this.commonVariableList.multi_attachments) {
        i.name = "";
        i.note_name = i.note_name ? i.note_name : "";
        i.remarks = i.remarks ? i.remarks : "";
        i.unique_id = i.unique_id ? i.unique_id : "";
        i.attachments = i.attachments ? i.attachments : [];
        let t = this.company_setup.questionnaire_upload_table_in_irn.filter((v)=>{return v.id == i.unique_id});
        if(t.length!=undefined && t.length > 0) {
          i.name = t[0].name;
        }
      }
    }
    this.makeData();

  }

  getAdditionalAttachmentTitle() {
    if (this.tableDetails && this.tableDetails.id == 'gatepassreport') {
      return 'Additional Gate Pass Attachment';
    }
    return 'Additional GRN Attachment';
  }

  showGatePass(data: any) {
    this.commonVariableList.items = [];
    this.commonVariableList.totalList = {};
    this.commonVariableList.extraItems = [];

    this.commonVariableList.multi_attachments = data && data.multi_attachments ? data.multi_attachments : [];
    this.company_setup.questionnaire_upload_table_in_gate_pass = this.company_setup.questionnaire_upload_table_in_gate_pass ? this.company_setup.questionnaire_upload_table_in_gate_pass : [];

    // Same as IRN view: use configured list for display names if available, else show what API gives
    if (this.company_setup.questionnaire_upload_table_in_gate_pass.length == 0) {
      for (let i of this.commonVariableList.multi_attachments) {
        i.name = i.name ? i.name : '';
        i.note_name = i.note_name ? i.note_name : '';
        i.remarks = i.remarks ? i.remarks : '';
        i.unique_id = i.unique_id ? i.unique_id : '';
        i.attachments = i.attachments ? i.attachments : [];
      }
      this.makeData();
      return;
    }

    if (this.company_setup.questionnaire_upload_table_in_gate_pass.length == 0) {
      this.commonVariableList.multi_attachments = [];
    } else {
      for (let i of this.commonVariableList.multi_attachments) {
        i.name = "";
        i.note_name = i.note_name ? i.note_name : "";
        i.remarks = i.remarks ? i.remarks : "";
        i.unique_id = i.unique_id ? i.unique_id : "";
        i.attachments = i.attachments ? i.attachments : [];
        let t = this.company_setup.questionnaire_upload_table_in_gate_pass.filter((v) => { return v.id == i.unique_id });
        if (t.length != undefined && t.length > 0) {
          i.name = t[0].name;
        }
      }
    }
    this.makeData();
  }
  showGrn(data) {
    this.commonVariableList.items = [];
    this.commonVariableList.totalList = {};
    this.commonVariableList.extraItems = [];
    this.commonVariableList.acceptedList = data.acceptedList ? data.acceptedList : [];
    this.commonVariableList.rejectedList = data.rejectedList ? data.rejectedList : [];

    this.commonVariableList.grn_acceptedList = data.grn_acceptedList ? data.grn_acceptedList : [];
    this.commonVariableList.grn_rejectedList = data.grn_rejectedList ? data.grn_rejectedList : [];

    this.commonVariableList.irn_grn_other_info=[];

    this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : "2";
      this.commonVariableList.multi_attachments = data.multi_attachments ? data.multi_attachments : [];
      this.company_setup.is_note_visible= this.company_setup.irn_grn_other_info.some((v)=>{return v.is_note_visible})?'1':'0';
      this.company_setup.is_remarks_visible= this.company_setup.irn_grn_other_info.some((v)=>{return v.is_remarks_visible})?'1':'0';
    if(this.company_setup.questionnaire_upload_table_in_irn.length==0) {
      this.commonVariableList.multi_attachments = [];
    } else {
      for(let i of this.commonVariableList.multi_attachments) {
        i.name = "";
        i.note_name = i.note_name ? i.note_name : "";
        i.remarks = i.remarks ? i.remarks : "";
        i.unique_id = i.unique_id ? i.unique_id : "";
        i.attachments = i.attachments ? i.attachments : [];
        let t = this.company_setup.questionnaire_upload_table_in_irn.filter((v)=>{return v.id == i.unique_id});
        if(t.length!=undefined && t.length > 0) {
          i.name = t[0].name;
          // i.note_name = t[0].note_name;
        }
      }}

    if(this.commonVariableList.grn_acceptedList)
    {
      for(let i of this.commonVariableList.grn_acceptedList)
      {
        i.quantity=this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);
        i.quantity=parseFloat(i.quantity);
        i.quantity=this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);

      }
    }
    if(this.commonVariableList.grn_rejectedList)
    {
      for(let i of this.commonVariableList.grn_rejectedList)
      {
        i.quantity=this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);
        i.quantity=parseFloat(i.quantity);
        i.quantity=this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);

      }
    }
    let keys:any=[];
    data.grn_other_info=data.grn_other_info?data.grn_other_info:[];
    if(data.grn_other_info.length>0)
    {
       for(var i in data.grn_other_info){
        var key = i;
        var val = data.grn_other_info[i];
        //console.log(val);
        let key_list:any={};
        let columns=[];
        for(var j in val){
            var sub_key = j;
            var sub_val = val[j];
            // keys.push({'columns':{'key':sub_val,'id':sub_key}});
            key_list.id=sub_key;
            key_list.key=sub_val;
             columns.push({'id':sub_key,'key':sub_val});
        }
         keys.push({"columns":columns});
    }
       data.grn_other_info=[];
       data.grn_other_info=keys?keys:[];
       this.commonVariableList.irn_grn_other_info=data.grn_other_info?data.grn_other_info:[]
       this.commonVariableList.irn_grn_other_info_total_row={
        actual_weight_total:data.actual_weight_total?data.actual_weight_total:'',
        volumetric_weight_total:data.volumetric_weight_total?data.volumetric_weight_total:'',
        chargeable_weight_total:data.chargeable_weight_total?data.chargeable_weight_total:'',
      }
    }
    this.makeData();

  }
  showDCNote(data) {
    data.items.forEach((item)=>{
   
      item.gst_checked = item.check_gst_status == '1' ? true : false;
    })
    globalVariables.dcNoteVariableList.columnList.forEach((val)=>{
       if(val.value == 'gst_checked'){
        val.is_view = data.show_gst == '1'? true :false
       }
    })
    this.commonVariableList.items = [];
    this.commonVariableList.totalList = {};
    this.commonVariableList.extraItems = [];
    this.commonVariableList.items.push(
      { "title": 'Total Amount', "amount": data.amount ? data.amount : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": 'Total CGST', "amount": data.cgst ? data.cgst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": parseFloat((data.cgst ? data.cgst : '0'))>0?true:false },
      { "title": 'Total SGST', "amount": data.sgst ? data.sgst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": parseFloat((data.sgst ? data.sgst : '0'))>0?true:false  },
      { "title": 'Total IGST', "amount": data.igst ? data.igst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": parseFloat((data.igst ? data.igst : '0'))>0?true:false  },
      { "title": 'Total UGST', "amount": data.ugst ? data.ugst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": parseFloat((data.ugst ? data.ugst : '0'))>0 ?true:false },
      { "title": 'Total CESS', "amount": data.cess ? data.cess : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": parseFloat((data.cess ? data.cess : '0'))>0 ?true:false },
      { "title": 'Total Other Tax', "amount": data.other_tax ? data.other_tax : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": parseFloat((data.other_tax ? data.other_tax : '0'))>0 },
      { "title": 'Total GST', "amount": data.total_gst ? data.total_gst : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },
      { "title": 'Grand Total', "amount": data.total_amount ? data.total_amount : '', "is_col_span": false, "col_span": '0',is_ddc_view:false, "is_view": true },

    )

    data.location_allocation_list = data.location_allocation_list ? data.location_allocation_list : []
    data.department_allocation_list =(data.location_allocation_list.length>0)?data.location_allocation_list:(data.department_allocation_list ? data.department_allocation_list:[])
    this.commonVariableList.is_department_allocation_visible = data.location_allocation_list.length > 0 ? true : false;

    this.commonVariableList.is_customer_allocation_visible = false;
    this.commonVariableList.is_account_type = false;
    this.commonVariableList.account_type_field_list = [];
    this.commonVariableList.invoice_allocate_to_employee_visible = false;
    this.commonVariableList.department_allocation_list = data.location_allocation_list;
    this.commonVariableList.is_deaprtment_list=data.location_allocation_list.length>0?true:false;
    this.department_tax_column_visible = this.commonVariableList.department_allocation_list.some((v)=>{return parseFloat(this.webService.convertNaN(v.gst_amount))>0})
    this.commonVariableList.is_different_document_currency=data.is_different_document_currency=='1'?true:false;

    if(data.department_allocation_list)
    {
      for(let i of data.department_allocation_list)
      {
        if(data.location_allocation_list.length>0)
        {
            i.department_name=i.nick_name+"("+i.nine_digit_code+")";
            i.cost_centre_name=i.cost_centre_name?i.cost_centre_name:(i.location?i.location:'')
            i.gst_no=i.gst_no?i.gst_no:'';
            if(i.gst_no!=''&&i.gst_no!=undefined&&i.gst_no!=null && this.company_setup.display_gstin_with_cost_center_and_vendor=='1')
            {
              i.department_name=i.department_name+"("+this.company_setup.gstin_display_label+" - "+i.gst_no+")";
            }
        }
      }
    }

  }
  showVendorCreditNote(data) {
    this.commonVariableList.items = [];
    this.commonVariableList.totalList = {};
    this.commonVariableList.extraItems = [];
    this.commonVariableList.items.push(
      { "title": 'Total Amount', "amount": data.amount ? data.amount : '', "is_col_span": false, "col_span": '0', is_ddc_view: false, "is_view": true },
      { "title": 'Total CGST', "amount": data.cgst ? data.cgst : '', "is_col_span": false, "col_span": '0', is_ddc_view: false, "is_view": parseFloat((data.cgst ? data.cgst : '0')) > 0 ? true : false },
      { "title": 'Total SGST', "amount": data.sgst ? data.sgst : '', "is_col_span": false, "col_span": '0', is_ddc_view: false, "is_view": parseFloat((data.sgst ? data.sgst : '0')) > 0 ? true : false },
      { "title": 'Total IGST', "amount": data.igst ? data.igst : '', "is_col_span": false, "col_span": '0', is_ddc_view: false, "is_view": parseFloat((data.igst ? data.igst : '0')) > 0 ? true : false },
      { "title": 'Total UGST', "amount": data.ugst ? data.ugst : '', "is_col_span": false, "col_span": '0', is_ddc_view: false, "is_view": parseFloat((data.ugst ? data.ugst : '0')) > 0 ? true : false },
      { "title": 'Total CESS', "amount": data.cess ? data.cess : '', "is_col_span": false, "col_span": '0', is_ddc_view: false, "is_view": parseFloat((data.cess ? data.cess : '0')) > 0 ? true : false },
      { "title": 'Total Other Tax', "amount": data.other_tax ? data.other_tax : '', "is_col_span": false, "col_span": '0', is_ddc_view: false, "is_view": parseFloat((data.other_tax ? data.other_tax : '0')) > 0 },
      { "title": 'Total GST', "amount": data.total_gst ? data.total_gst : '', "is_col_span": false, "col_span": '0', is_ddc_view: false, "is_view": true },
      { "title": 'Grand Total', "amount": data.total_amount ? data.total_amount : '', "is_col_span": false, "col_span": '0', is_ddc_view: false, "is_view": true },

    )

    data.location_allocation_list = data.location_allocation_list ? data.location_allocation_list : []
    data.department_allocation_list = (data.location_allocation_list.length > 0) ? data.location_allocation_list : (data.department_allocation_list ? data.department_allocation_list : [])
    this.commonVariableList.is_department_allocation_visible = data.location_allocation_list.length > 0 ? true : false;

    this.commonVariableList.is_customer_allocation_visible = false;
    this.commonVariableList.is_account_type = false;
    this.commonVariableList.account_type_field_list = [];
    this.commonVariableList.invoice_allocate_to_employee_visible = false;
    this.commonVariableList.department_allocation_list = data.location_allocation_list;
    this.commonVariableList.is_deaprtment_list = data.location_allocation_list.length > 0 ? true : false;
    this.department_tax_column_visible = this.commonVariableList.department_allocation_list.some((v) => { return parseFloat(this.webService.convertNaN(v.gst_amount)) > 0 })
    this.commonVariableList.is_different_document_currency = data.is_different_document_currency == '1' ? true : false;

    if (data.department_allocation_list) {
      for (let i of data.department_allocation_list) {
        if (data.location_allocation_list.length > 0) {
          i.department_name = i.nick_name + "(" + i.nine_digit_code + ")";
          i.cost_centre_name = i.cost_centre_name ? i.cost_centre_name : (i.location ? i.location : '')
          i.gst_no = i.gst_no ? i.gst_no : '';
          if (i.gst_no != '' && i.gst_no != undefined && i.gst_no != null && this.company_setup.display_gstin_with_cost_center_and_vendor=='1') {
            i.department_name = i.department_name + "(" + this.company_setup.gstin_display_label + " - " + i.gst_no + ")";
          }
        }
      }
    }

  }
  is_ddc:boolean=false;
  department_tax_column_visible:boolean=false;
  showTdsTable:boolean=true;
  showInvoice(data) {
    data.show_multi_inv = data.show_multi_inv ? data.show_multi_inv : '0';
    data.tds_amount = data.tds_amount ? data.tds_amount : "0";
    console.log("data.tds_amount", data.tds_amount);
    if(parseFloat(this.webService.convertNaN(data.tds_amount)) > 0) {
      console.log("showTdsTable true");
      this.showTdsTable = true;
    } else {
      console.log("showTdsTable false");
      this.showTdsTable = false;
    }
    // Same read-only Accepted/Rejected tabs as GRN hyperlink (generic-grand-table).
    this.commonVariableList.grn_acceptedList = data.grn_acceptedList ? data.grn_acceptedList : [];
    this.commonVariableList.grn_rejectedList = data.grn_rejectedList ? data.grn_rejectedList : [];
    this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : "2";
    if (this.commonVariableList.grn_acceptedList) {
      for (let i of this.commonVariableList.grn_acceptedList) {
        i.quantity = this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);
        i.quantity = parseFloat(i.quantity);
        i.quantity = this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);
      }
    }
    if (this.commonVariableList.grn_rejectedList) {
      for (let i of this.commonVariableList.grn_rejectedList) {
        i.quantity = this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);
        i.quantity = parseFloat(i.quantity);
        i.quantity = this.webService.convertNaN(i.quantity, this.company_setup.allowed_digits_after_decimal);
      }
    }
    let is_goods: boolean = false;
    this.is_dimension=false;
    this.is_ddc=data.is_different_document_currency=='1'?true:false;
    let totJournalCgst = 0;
    let totJournalSgst = 0;
    let totJournalIgst = 0;
    let totJournalCess = 0;
    let totJournalUgst = 0;
    let totJournalOtherTax = 0;
    let totJournalTax = 0;
    if(this.page_url == 'invoice-approval' || this.page_url == 'invoice-summary') {
      for(let i of data.invoice_items) {
        if(i.rcm_applicable == '1') {
          totJournalCgst += parseFloat(i.journal_cgst);
          totJournalSgst += parseFloat(i.journal_sgst);
          totJournalIgst += parseFloat(i.journal_igst);
          totJournalCess += parseFloat(i.journal_cess);
          totJournalUgst += parseFloat(i.journal_ugst);
          totJournalOtherTax += parseFloat(i.journal_other_tax);

          let journalTax = parseFloat(i.journal_cgst) + parseFloat(i.journal_sgst) + parseFloat(i.journal_igst) + parseFloat(i.journal_cess) + parseFloat(i.journal_ugst) + parseFloat(i.journal_other_tax);
          totJournalTax += journalTax;
        }
      }
      this.rcmGstData.totJournalCgst = totJournalCgst;
      this.rcmGstData.totJournalSgst = totJournalSgst;
      this.rcmGstData.totJournalIgst = totJournalIgst;
      this.rcmGstData.totJournalCess = totJournalCess;
      this.rcmGstData.totJournalUgst = totJournalUgst;
      this.rcmGstData.totJournalOtherTax = totJournalOtherTax;
      this.rcmGstData.totJournalTax = totJournalTax;
      this.showRcmGstData = this.rcmGstData.totJournalTax>0 ? true : false;
    } else {
      this.showRcmGstData = false;
    }
    // console.log('hey input'+data.is_different_document_currency+' is_ddc'+this.is_ddc)
    is_goods = data.invoice_items.every((v) => { return v.product_type == 'goods' })
    this.attachment=this.webService.makeAttachment(this.tableDetails.data.tds_attachments);

    this.commonVariableList.is_different_document_currency = this.is_ddc ? this.is_ddc : false;
    this.commonVariableList.is_goods = data.invoice_items.every((v) => { return v.product_type == 'goods' })
    data.is_account_type = data.is_account_type ? data.is_account_type : '0'
    data.is_customer_allocation_visible = data.is_customer_allocation_visible ? data.is_customer_allocation_visible : '0'
    data.is_department_allocation_visible = data.is_department_allocation_visible ? data.is_department_allocation_visible : '0'
    data.invoice_allocate_to_employee = data.invoice_allocate_to_employee ? data.invoice_allocate_to_employee : ""
    data.is_vendor_invoice=data.is_vendor_invoice?data.is_vendor_invoice:'0';
    data.location_allocation_list = data.location_allocation_list ? data.location_allocation_list : [];
    this.commonVariableList.amount_mismatch_message = data.amount_mismatch_message ? data.amount_mismatch_message : "";
    this.commonVariableList.is_amount_mismatch = data.is_amount_mismatch ? data.is_amount_mismatch : '0';
    this.commonVariableList.is_deaprtment_list=data.location_allocation_list.length>0?true:false;
    data.department_allocation_list =(data.location_allocation_list.length>0)?data.location_allocation_list:(data.department_allocation_list ? data.department_allocation_list:[])
    if(data.department_allocation_list)
    {
      for(let i of data.department_allocation_list)
      {
        if(data.location_allocation_list.length>0)
        {
            i.department_name=i.nick_name+"("+i.nine_digit_code+")";
            i.cost_centre_name=i.cost_centre_name?i.cost_centre_name:(i.location?i.location:'')
            i.gst_no=i.gst_no?i.gst_no:'';
            i.product_name = i.product_name+'('+i.productcode+') - Row '+i.row_no;
            if(i.gst_no!=''&&i.gst_no!=undefined&&i.gst_no!=null && this.company_setup.display_gstin_with_cost_center_and_vendor=='1')
            {
              i.department_name=i.department_name+"("+this.company_setup.gstin_display_label+" - "+i.gst_no+")";
            }
        }
      }
    }


    data.account_type_field_list = data.account_type_field_list ? data.account_type_field_list : []
    data.customer_allocation_list = data.customer_allocation_list ? data.customer_allocation_list : []
    data.employee_allocation_list = data.employee_allocation_list ? data.employee_allocation_list : []
    if(data.employee_allocation_list){
      for(let d of data.employee_allocation_list) {
        d.name = d.first_name ? `${d.first_name} ${d.last_name} (${d.employee_code})` : "";
        d.amount = d.amount ? d.amount : "";
        d.fcamount = d.fcamount ? d.fcamount : "";
        d.remarks = d.remarks ? d.remarks : "";
      }
    }
    this.commonVariableList.is_account_type = data.is_account_type == '1' && data.account_type_field_list.length > 0 ? true : false;
    this.commonVariableList.is_customer_allocation_visible = data.is_customer_allocation_visible == '1' ? true : false;
    this.commonVariableList.is_department_allocation_visible = data.is_department_allocation_visible == '1' ? true : false;
    this.commonVariableList.invoice_allocate_to_employee_visible = data.invoice_allocate_to_employee == '1' ? true : false;

    this.commonVariableList.department_allocation_list = data.department_allocation_list ? data.department_allocation_list : []
    this.commonVariableList.is_allocate_auto_populate = data.is_allocate_auto_populate == '1';
    this.commonVariableList.is_allocate_populate_and_summarize = data.is_allocate_populate_and_summarize == '1';
    this.department_tax_column_visible=this.commonVariableList.department_allocation_list.some((v)=>{return parseFloat(this.webService.convertNaN(v.gst_amount))>0})

    this.commonVariableList.account_type_field_list = data.account_type_field_list ? data.account_type_field_list : []
    this.commonVariableList.customer_allocation_list = data.customer_allocation_list ? data.customer_allocation_list : []
    this.commonVariableList.employee_allocation_list = data.employee_allocation_list ? data.employee_allocation_list : []
    this.commonVariableList.additional_field_invoice_column_list = data.additional_field_invoice_column_list ? data . additional_field_invoice_column_list :[]
    if(this.commonVariableList.customer_allocation_list) {
      this.commonVariableList.customer_allocation_list.forEach((d)=>{
        d.customer_first_name = d.first_name ? d.first_name : "";
        d.customer_last_name = d.last_name ? d.last_name : "";
        d.customer_location_name = d.customer_address ? d.customer_address : "";

      })
    }
    this.is_dimension=this.commonVariableList.department_allocation_list.some((v)=>{return v.dimension_name!='' && v.dimension_name!=null && v.dimension_name!=undefined})
//Start Code : to convert into two digi fater decimal

data.total_invoice_amount = this.webService.convertNaN(data.total_invoice_amount)
data.total_paid_amount = this.webService.convertNaN(data.total_paid_amount)
data.total_amount_difference = this.webService.convertNaN(data.total_amount_difference)

data.total_invoice_sgst = this.webService.convertNaN(data.total_invoice_sgst)
data.total_paid_sgst = this.webService.convertNaN(data.total_paid_sgst)
data.total_sgst_difference = this.webService.convertNaN(data.total_sgst_difference)


data.total_invoice_cgst = this.webService.convertNaN(data.total_invoice_cgst)
data.total_paid_cgst = this.webService.convertNaN(data.total_paid_cgst)
data.total_cgst_difference = this.webService.convertNaN(data.total_cgst_difference)

data.total_invoice_igst = this.webService.convertNaN(data.total_invoice_igst)
data.total_paid_igst = this.webService.convertNaN(data.total_paid_igst)
data.total_igst_difference = this.webService.convertNaN(data.total_igst_difference)

data.total_invoice_cess = this.webService.convertNaN(data.total_invoice_cess)
data.total_paid_cess = this.webService.convertNaN(data.total_paid_cess)
data.total_cess_difference = this.webService.convertNaN(data.total_cess_difference)

data.total_invoice_ugst = this.webService.convertNaN(data.total_invoice_ugst)
data.total_paid_ugst = this.webService.convertNaN(data.total_paid_ugst)
data.total_ugst_difference = this.webService.convertNaN(data.total_ugst_difference)

data.total_invoice_other_tax = this.webService.convertNaN(data.total_invoice_other_tax)
data.total_paid_other_tax = this.webService.convertNaN(data.total_paid_other_tax)
data.total_other_tax_difference = this.webService.convertNaN(data.total_other_tax_difference)


data.total_invoice_tax = this.webService.convertNaN(data.total_invoice_tax)
data.total_paid_tax = this.webService.convertNaN(data.total_paid_tax)
data.total_tax_difference = this.webService.convertNaN(data.total_tax_difference)


data.grand_total_invoice_amount = this.webService.convertNaN(data.grand_total_invoice_amount)
data.grand_total_paid_amount = this.webService.convertNaN(data.grand_total_paid_amount)
data.grand_total_difference = this.webService.convertNaN(data.grand_total_difference)



data.tds_amount = this.webService.convertNaN(data.tds_amount)
data.previous_tds_amount = this.webService.convertNaN(data.previous_tds_amount)
data.installation_charge = this.webService.convertNaN(data.installation_charge)
data.freight_cost = this.webService.convertNaN(data.freight_cost)
data.discount_value = this.webService.convertNaN(data.discount_value)
data.advance_amount = this.webService.convertNaN(data.advance_amount)
data.adjusted_amount = this.webService.convertNaN(data.adjusted_amount)


data.total_invoice_amount = parseFloat(data.total_invoice_amount)
data.total_paid_amount = parseFloat(data.total_paid_amount)
data.total_amount_difference = parseFloat(data.total_amount_difference)

data.total_invoice_sgst = parseFloat(data.total_invoice_sgst)
data.total_paid_sgst = parseFloat(data.total_paid_sgst)
data.total_sgst_difference = parseFloat(data.total_sgst_difference)


data.total_invoice_cgst = parseFloat(data.total_invoice_cgst)
data.total_paid_cgst = parseFloat(data.total_paid_cgst)
data.total_cgst_difference = parseFloat(data.total_cgst_difference)

data.total_invoice_igst = parseFloat(data.total_invoice_igst)
data.total_paid_igst = parseFloat(data.total_paid_igst)
data.total_igst_difference = parseFloat(data.total_igst_difference)

data.total_invoice_cess = parseFloat(data.total_invoice_cess)
data.total_paid_cess = parseFloat(data.total_paid_cess)
data.total_cess_difference = parseFloat(data.total_cess_difference)

data.total_invoice_ugst = parseFloat(data.total_invoice_ugst)
data.total_paid_ugst = parseFloat(data.total_paid_ugst)
data.total_ugst_difference = parseFloat(data.total_ugst_difference)

data.total_invoice_other_tax = parseFloat(data.total_invoice_other_tax)
data.total_paid_other_tax = parseFloat(data.total_paid_other_tax)
data.total_other_tax_difference = parseFloat(data.total_other_tax_difference)


data.total_invoice_tax = parseFloat(data.total_invoice_tax)
data.total_paid_tax = parseFloat(data.total_paid_tax)
data.total_tax_difference = parseFloat(data.total_tax_difference)


data.grand_total_invoice_amount = parseFloat(data.grand_total_invoice_amount)
data.grand_total_paid_amount = parseFloat(data.grand_total_paid_amount)
data.grand_total_difference = parseFloat(data.grand_total_difference)



data.tds_amount = parseFloat(data.tds_amount)
data.previous_tds_amount = parseFloat(data.previous_tds_amount)
data.installation_charge = parseFloat(data.installation_charge)
data.freight_cost = parseFloat(data.freight_cost)
data.discount_value = parseFloat(data.discount_value)
data.advance_amount = parseFloat(data.advance_amount)
data.adjusted_amount = parseFloat(data.adjusted_amount)


data.total_invoice_amount = this.webService.convertNaN(data.total_invoice_amount)
data.total_paid_amount = this.webService.convertNaN(data.total_paid_amount)
data.total_amount_difference = this.webService.convertNaN(data.total_amount_difference)

data.total_invoice_sgst = this.webService.convertNaN(data.total_invoice_sgst)
data.total_paid_sgst = this.webService.convertNaN(data.total_paid_sgst)
data.total_sgst_difference = this.webService.convertNaN(data.total_sgst_difference)


data.total_invoice_cgst = this.webService.convertNaN(data.total_invoice_cgst)
data.total_paid_cgst = this.webService.convertNaN(data.total_paid_cgst)
data.total_cgst_difference = this.webService.convertNaN(data.total_cgst_difference)

data.total_invoice_igst = this.webService.convertNaN(data.total_invoice_igst)
data.total_paid_igst = this.webService.convertNaN(data.total_paid_igst)
data.total_igst_difference = this.webService.convertNaN(data.total_igst_difference)

data.total_invoice_cess = this.webService.convertNaN(data.total_invoice_cess)
data.total_paid_cess = this.webService.convertNaN(data.total_paid_cess)
data.total_cess_difference = this.webService.convertNaN(data.total_cess_difference)

data.total_invoice_ugst = this.webService.convertNaN(data.total_invoice_ugst)
data.total_paid_ugst = this.webService.convertNaN(data.total_paid_ugst)
data.total_ugst_difference = this.webService.convertNaN(data.total_ugst_difference)

data.total_invoice_other_tax = this.webService.convertNaN(data.total_invoice_other_tax)
data.total_paid_other_tax = this.webService.convertNaN(data.total_paid_other_tax)
data.total_other_tax_difference = this.webService.convertNaN(data.total_other_tax_difference)


data.total_invoice_tax = this.webService.convertNaN(data.total_invoice_tax)
data.total_paid_tax = this.webService.convertNaN(data.total_paid_tax)
data.total_tax_difference = this.webService.convertNaN(data.total_tax_difference)


data.grand_total_invoice_amount = this.webService.convertNaN(data.grand_total_invoice_amount)
data.grand_total_paid_amount = this.webService.convertNaN(data.grand_total_paid_amount)
data.grand_total_difference = this.webService.convertNaN(data.grand_total_difference)



data.tds_amount = this.webService.convertNaN(data.tds_amount)
data.previous_tds_amount = this.webService.convertNaN(data.previous_tds_amount)
data.installation_charge = this.webService.convertNaN(data.installation_charge)
data.freight_cost = this.webService.convertNaN(data.freight_cost)
data.discount_value = this.webService.convertNaN(data.discount_value)
data.advance_amount = this.webService.convertNaN(data.advance_amount)
data.adjusted_amount = this.webService.convertNaN(data.adjusted_amount)


data.proposed_pod_deduction_amount=this.webService.convertNaN(data.proposed_pod_deduction_amount);
data.proposed_cod_deduction_amount=this.webService.convertNaN(data.proposed_cod_deduction_amount);
data.approved_pod_deduction_amount=this.webService.convertNaN(data.approved_pod_deduction_amount);
data.approved_cod_deduction_amount=this.webService.convertNaN(data.approved_cod_deduction_amount);

data.proposed_pod_deduction_amount=parseFloat(data.proposed_pod_deduction_amount);
data.proposed_cod_deduction_amount=parseFloat(data.proposed_cod_deduction_amount);
data.approved_pod_deduction_amount=parseFloat(data.approved_pod_deduction_amount);
data.approved_cod_deduction_amount=parseFloat(data.approved_cod_deduction_amount);


data.proposed_pod_deduction_amount=this.webService.convertNaN(data.proposed_pod_deduction_amount);
data.proposed_cod_deduction_amount=this.webService.convertNaN(data.proposed_cod_deduction_amount);
data.approved_pod_deduction_amount=this.webService.convertNaN(data.approved_pod_deduction_amount);
data.approved_cod_deduction_amount=this.webService.convertNaN(data.approved_cod_deduction_amount);

data.mask_total_tds_amount=this.webService.convertNaN(parseFloat(this.webService.convertNaN(data.mask_total_tds_amount)));
data.total_tds_amount=this.webService.convertNaN(parseFloat(this.webService.convertNaN(data.total_tds_amount)));
console.log(data.is_ddc_grandTotal_difference)
// data.total_tds_amount=(parseFloat(data.total_tds_amount)<=0)?data.mask_total_tds_amount:data.total_tds_amount
// End Code : to convert into two digit after decimal
data.payment_details = data.payment_details ? data.payment_details : []
if(data.payment_details){
  for(let d of data.payment_details) {
    d.utr_no = d.utr_no ? d.utr_no : "";
    d.paid_amount = d.paid_amount ? d.paid_amount : "";
    d.payment_date = d.payment_date ? this.webService.formatDateAccordingToSetup(d.payment_date,this.company_setup.in_invoice_date_format) : "";
  }
}
this.commonVariableList.payment_details = data.payment_details ? data.payment_details : []
if(this.page_url == 'all-approved-invoices') {
  this.showPaymentDetailsTable = true;
}
if (this.commonVariableList.columnList) {
  for (let i of this.commonVariableList.columnList) {

    if (i.value == 'title') {
      i.display = this.company_setup.invoice_summary_title.main_title_1?this.company_setup.invoice_summary_title.main_title_1:'';
    }
    if (i.value == 'invoice_amount') {
      i.display = this.company_setup.invoice_summary_title.main_title_2?this.company_setup.invoice_summary_title.main_title_2:'';
    }
    if (i.value == 'paid_amount') {
      i.display = this.company_setup.invoice_summary_title.main_title_3?this.company_setup.invoice_summary_title.main_title_3:'';
    }
    if (i.value == 'difference_amount') {
      i.display = this.company_setup.invoice_summary_title.main_title_4?this.company_setup.invoice_summary_title.main_title_4:'';

      if(this.company_setup.is_inv_debit_note_disable && this.company_setup.is_inv_debit_note_disable == "1"){
        i.is_view = false
      }
      
    }


    if (i.value == 'is_ddc_total_invoice_amount') {
      i.display = (this.company_setup.invoice_summary_title.main_title_2?this.company_setup.invoice_summary_title.main_title_2:'')+"("+data.currency_code+")";
    }
    if (i.value == 'is_ddc_total_paid_amount') {
      i.display = (this.company_setup.invoice_summary_title.main_title_3?this.company_setup.invoice_summary_title.main_title_3:'')+"("+data.currency_code+")";
    }
    if (i.value == 'is_ddc_total_amount_difference') {
      i.display = (this.company_setup.invoice_summary_title.main_title_4?this.company_setup.invoice_summary_title.main_title_4:'')+"("+data.currency_code+")";
    }

    if (i.value == 'is_ddc_total_invoice_amount' && this.is_ddc) {
      i.is_view = true
      i.is_currency = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_invoice_amount' && !this.is_ddc) {
      i.is_view = false
      // i.is_ddc=false
    }

    if (i.value == 'is_ddc_total_paid_amount' && this.is_ddc) {
      i.is_view = true
      i.is_currency = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_paid_amount' && !this.is_ddc) {
      i.is_view = false
      // i.is_ddc=false
    }

    if (i.value == 'is_ddc_total_amount_difference' && this.is_ddc) {
      i.is_view = true
      i.is_currency = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_amount_difference' && !this.is_ddc) {
      i.is_view = false
      // i.is_ddc=false
    }
    if (i.value == 'is_ddc_total_invoice_amount' && this.is_ddc && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1') {
      i.is_view = true
      i.is_currency = false
      console.log('1 true')

      // i.is_ddc=true
    }

    if (i.value == 'is_ddc_total_invoice_amount' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc !='1') {
      i.is_view=false;
      console.log('not true1')

      // i.is_ddc=true
    }

    if (i.value == 'is_ddc_total_paid_amount' && this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1') {
      i.is_view = true
      i.is_currency = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_paid_amount' && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc !='1') {
      i.is_view = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_amount_difference' && this.is_ddc && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1' && this.company_setup.is_inv_debit_note_disable != "1") {
      i.is_view = true
      i.is_currency = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_amount_difference' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc !='1') {
      i.is_view = false
      console.log('not true3')
      // i.is_ddc=true
    }

  }
}

let url=window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
let is_approval:boolean=false;
is_approval=(url=='invoice-approval')?true:false;
let is_ddc_previous_tds_amount=data.is_ddc_previous_tds_amount?data.is_ddc_previous_tds_amount:'0'
let tds_amount=data.is_ddc_tds_amount?data.is_ddc_tds_amount:'0'
let total_tds_amount=data.is_ddc_total_tds_amount?data.is_ddc_total_tds_amount:'0'
if(parseFloat(total_tds_amount)!=parseFloat(tds_amount) && parseFloat(is_ddc_previous_tds_amount)==0)
{
  is_ddc_previous_tds_amount=parseFloat(total_tds_amount)-parseFloat(tds_amount)
  is_ddc_previous_tds_amount=this.webService.convertNaN(is_ddc_previous_tds_amount);
}
    let invoice_group_summary = {
      "total_invoice_amount": 0,
      "total_paid_amount": 0,
      "total_amount_difference": 0,
      "total_invoice_sgst": 0,
      "total_paid_sgst": 0,
      "total_sgst_difference": 0,
      "total_invoice_cgst": 0,
      "total_paid_cgst": 0,
      "total_cgst_difference": 0,
      "total_invoice_igst": 0,
      "total_paid_igst": 0,
      "total_igst_difference": 0,
      "total_invoice_ugst": 0,
      "total_paid_ugst": 0,
      "total_ugst_difference": 0,
      "total_invoice_cess": 0,
      "total_paid_cess": 0,
      "total_cess_difference": 0,
      "total_invoice_other_tax": 0,
      "total_paid_other_tax": 0,
      "total_other_tax_difference": 0,
      "total_invoice_tax": 0,
      "total_paid_tax": 0,
      "total_tax_difference": 0,
      "grand_total_paid_amount": 0,
      "grand_total_invoice_amount": 0,
      "grand_total_difference": 0,
      "tds_amount": 0,
      "round_grandTotal": 0,
      "roundedOff_grandTotal": 0,
      "adjusted_amount": 0,
      "grand_total": 0,
      "is_ddc_grandTotal": 0,
      "total_tds_amount": 0,
      "is_ddc_total_tds_amount": 0,
      "previous_tds_amount": 0,
      "is_ddc_total_invoice_amount": 0,
      "is_ddc_total_paid_amount": 0,
      "is_ddc_total_amount_difference": 0,
      "is_ddc_total_invoice_sgst": 0,
      "is_ddc_total_paid_sgst": 0,
      "is_ddc_total_sgst_difference": 0,
      "is_ddc_total_invoice_cgst": 0,
      "is_ddc_total_paid_cgst": 0,
      "is_ddc_total_cgst_difference": 0,
      "is_ddc_total_invoice_igst": 0,
      "is_ddc_total_paid_igst": 0,
      "is_ddc_total_igst_difference": 0,
      "is_ddc_total_invoice_ugst": 0,
      "is_ddc_total_paid_ugst": 0,
      "is_ddc_total_ugst_difference": 0,
      "is_ddc_total_invoice_cess": 0,
      "is_ddc_total_paid_cess": 0,
      "is_ddc_total_cess_difference": 0,
      "is_ddc_total_invoice_other_tax": 0,
      "is_ddc_total_paid_other_tax": 0,
      "is_ddc_total_other_tax_difference": 0,
      "is_ddc_total_invoice_tax": 0,
      "is_ddc_total_paid_tax": 0,
      "is_ddc_total_tax_difference": 0,
      "is_ddc_grandTotal_paid_amount": 0,
      "is_ddc_grandTotal_difference": 0,
      "is_ddc_tds_amount": 0,
      "is_ddc_previous_tds_amount": 0,
      "total_gst_tds_igst_amount": 0,
      "total_gst_tds_cgst_amount": 0,
      "total_gst_tds_sgst_amount": 0,
      "total_gst_tds_ugst_amount": 0,
     

    }
    data.invoice_group_summary = data.invoice_group_summary ? data.invoice_group_summary : invoice_group_summary;
    let total_invoice_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.total_invoice_amount : data.total_invoice_amount;
    let total_paid_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.total_paid_amount : data.total_paid_amount;
    let total_amount_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.total_amount_difference : data.total_amount_difference;
    let total_invoice_sgst = data.show_multi_inv == '1' ? data.invoice_group_summary.total_invoice_sgst : data.total_invoice_sgst;
    let total_paid_sgst = data.show_multi_inv == '1' ? data.invoice_group_summary.total_paid_sgst : data.total_paid_sgst;
    let total_sgst_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.total_sgst_difference : data.total_sgst_difference;
    let total_invoice_cgst = data.show_multi_inv == '1' ? data.invoice_group_summary.total_invoice_cgst : data.total_invoice_cgst;
    let total_paid_cgst = data.show_multi_inv == '1' ? data.invoice_group_summary.total_paid_cgst : data.total_paid_cgst;
    let total_cgst_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.total_cgst_difference : data.total_cgst_difference;
    let total_invoice_igst = data.show_multi_inv == '1' ? data.invoice_group_summary.total_invoice_igst : data.total_invoice_igst;
    let total_paid_igst = data.show_multi_inv == '1' ? data.invoice_group_summary.total_paid_igst : data.total_paid_igst;
    let total_igst_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.total_igst_difference : data.total_igst_difference;
    let total_invoice_ugst = data.show_multi_inv == '1' ? data.invoice_group_summary.total_invoice_ugst : data.total_invoice_ugst;
    let total_paid_ugst = data.show_multi_inv == '1' ? data.invoice_group_summary.total_paid_ugst : data.total_paid_ugst;
    let total_ugst_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.total_ugst_difference : data.total_ugst_difference;
    let total_invoice_cess = data.show_multi_inv == '1' ? data.invoice_group_summary.total_invoice_cess : data.total_invoice_cess;
    let total_paid_cess = data.show_multi_inv == '1' ? data.invoice_group_summary.total_paid_cess : data.total_paid_cess;
    let total_cess_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.total_cess_difference : data.total_cess_difference;
    let total_invoice_other_tax = data.show_multi_inv == '1' ? data.invoice_group_summary.total_invoice_other_tax : data.total_invoice_other_tax;
    let total_paid_other_tax = data.show_multi_inv == '1' ? data.invoice_group_summary.total_paid_other_tax : data.total_paid_other_tax;
    let total_other_tax_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.total_other_tax_difference : data.total_other_tax_difference;
    let total_invoice_tax = data.show_multi_inv == '1' ? data.invoice_group_summary.total_invoice_tax : data.total_invoice_tax;
    let total_paid_tax = data.show_multi_inv == '1' ? data.invoice_group_summary.total_paid_tax : data.total_paid_tax;
    let total_tax_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.total_tax_difference : data.total_tax_difference;
    let grand_total_paid_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.grand_total_paid_amount : data.grand_total_paid_amount;
    let grand_total_invoice_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.grand_total_invoice_amount : data.grand_total_invoice_amount;
    let grand_total_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.grand_total_difference : data.grand_total_difference;
    tds_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.tds_amount : data.tds_amount;
    let round_grandTotal = data.show_multi_inv == '1' ? data.invoice_group_summary.round_grandTotal : data.round_grandTotal;
    let roundedOff_grandTotal = data.show_multi_inv == '1' ? data.invoice_group_summary.roundedOff_grandTotal : data.roundedOff_grandTotal;
    let adjusted_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.adjusted_amount : data.adjusted_amount;
    let grand_total = data.show_multi_inv == '1' ? data.invoice_group_summary.grand_total : data.grand_total;
    let previous_tds_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.previous_tds_amount : data.previous_tds_amount;
    let is_ddc_total_invoice_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_invoice_amount : data.is_ddc_total_invoice_amount;
    let is_ddc_total_paid_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_paid_amount : data.is_ddc_total_paid_amount;
    let is_ddc_total_amount_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_amount_difference : data.is_ddc_total_amount_difference;
    let is_ddc_total_invoice_sgst = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_invoice_sgst : data.is_ddc_total_invoice_sgst;
    let is_ddc_total_paid_sgst = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_paid_sgst : data.is_ddc_total_paid_sgst;
    let is_ddc_total_sgst_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_sgst_difference : data.is_ddc_total_sgst_difference;
    let is_ddc_total_invoice_cgst = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_invoice_cgst : data.is_ddc_total_invoice_cgst;
    let is_ddc_total_paid_cgst = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_paid_cgst : data.is_ddc_total_paid_cgst;
    let is_ddc_total_cgst_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_cgst_difference : data.is_ddc_total_cgst_difference;
    let is_ddc_total_invoice_igst = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_invoice_igst : data.is_ddc_total_invoice_igst;
    let is_ddc_total_paid_igst = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_paid_igst : data.is_ddc_total_paid_igst;
    let is_ddc_total_igst_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_igst_difference : data.is_ddc_total_igst_difference;
    let is_ddc_total_invoice_ugst = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_invoice_ugst : data.is_ddc_total_invoice_ugst;
    let is_ddc_total_paid_ugst = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_paid_ugst : data.is_ddc_total_paid_ugst;
    let is_ddc_total_ugst_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_ugst_difference : data.is_ddc_total_ugst_difference;
    let is_ddc_total_invoice_cess = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_invoice_cess : data.is_ddc_total_invoice_cess;
    let is_ddc_total_paid_cess = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_paid_cess : data.is_ddc_total_paid_cess;
    let is_ddc_total_cess_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_cess_difference : data.is_ddc_total_cess_difference;
    let is_ddc_total_invoice_other_tax = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_invoice_other_tax : data.is_ddc_total_invoice_other_tax;
    let is_ddc_total_paid_other_tax = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_paid_other_tax : data.is_ddc_total_paid_other_tax;
    let is_ddc_total_other_tax_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_other_tax_difference : data.is_ddc_total_other_tax_difference;
    let is_ddc_total_invoice_tax = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_invoice_tax : data.is_ddc_total_invoice_tax;
    let is_ddc_total_paid_tax = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_paid_tax : data.is_ddc_total_paid_tax;
    let is_ddc_total_tax_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_tax_difference : data.is_ddc_total_tax_difference;
    let is_ddc_grandTotal_paid_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_grandTotal_paid_amount : data.is_ddc_grandTotal_paid_amount;
    let is_ddc_grandTotal_difference = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_grandTotal_difference : data.is_ddc_grandTotal_difference;
    let is_ddc_tds_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_tds_amount : data.is_ddc_tds_amount;
    is_ddc_previous_tds_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_previous_tds_amount : data.is_ddc_previous_tds_amount;
    let total_gst_tds_cgst_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.total_gst_tds_cgst_amount : data.total_gst_tds_cgst_amount;
    let total_gst_tds_sgst_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.total_gst_tds_sgst_amount : data.total_gst_tds_sgst_amount;
    let total_gst_tds_ugst_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.total_gst_tds_ugst_amount : data.total_gst_tds_ugst_amount;
    total_tds_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.total_tds_amount : data.total_tds_amount;
    let total_gst_tds_igst_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.total_gst_tds_igst_amount : data.total_gst_tds_igst_amount;
    let is_ddc_total_tds_amount = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_total_tds_amount : data.is_ddc_total_tds_amount;
    let is_ddc_grandTotal = data.show_multi_inv == '1' ? data.invoice_group_summary.is_ddc_grandTotal : data.is_ddc_grandTotal;

    this.commonVariableList.items.push(
      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_amount','Total Amount').custom_title,
       "invoice_amount": total_invoice_amount, "paid_amount": total_paid_amount, "difference_amount": total_amount_difference,
       "is_ddc_total_invoice_amount": is_ddc_total_invoice_amount, "is_ddc_total_paid_amount": is_ddc_total_paid_amount, "is_ddc_total_amount_difference": is_ddc_total_amount_difference,
       "is_col_span": false, "col_span": '0',
       is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_amount',true).is_visible },

      { "title":this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_sgst','Total SGST').custom_title,
       "invoice_amount": total_invoice_sgst, "paid_amount": total_paid_sgst, "difference_amount": total_sgst_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": is_ddc_total_invoice_sgst, "is_ddc_total_paid_amount": is_ddc_total_paid_sgst, "is_ddc_total_amount_difference": is_ddc_total_sgst_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_sgst',true).is_visible && this. company_setup.custom_sgst_visible == '1' },

      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_cgst','Total CGST').custom_title,
       "invoice_amount": total_invoice_cgst, "paid_amount": total_paid_cgst, "difference_amount": total_cgst_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": is_ddc_total_invoice_cgst, "is_ddc_total_paid_amount": is_ddc_total_paid_cgst, "is_ddc_total_amount_difference": is_ddc_total_cgst_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_cgst',true).is_visible && this. company_setup.custom_cgst_visible == '1' },

      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_igst','Total IGST').custom_title,
       "invoice_amount": total_invoice_igst, "paid_amount": total_paid_igst, "difference_amount": total_igst_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": is_ddc_total_invoice_igst, "is_ddc_total_paid_amount": is_ddc_total_paid_igst, "is_ddc_total_amount_difference": is_ddc_total_igst_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_igst',true).is_visible && this. company_setup.custom_igst_visible == '1' },

      { "title":this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_ugst','Total UGST').custom_title,
       "invoice_amount": total_invoice_ugst, "paid_amount": total_paid_ugst, "difference_amount": total_ugst_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": data.is_ddc_total_invoice_ugst, "is_ddc_total_paid_amount": data.is_ddc_total_paid_ugst, "is_ddc_total_amount_difference": data.is_ddc_total_ugst_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_ugst',true).is_visible && this. company_setup.custom_ugst_visible == '1' && data.total_invoice_ugst > 0 },

      { "title":this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_cess','Total CESS').custom_title,
       "invoice_amount": total_invoice_cess, "paid_amount": total_paid_cess, "difference_amount": total_cess_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": is_ddc_total_invoice_cess, "is_ddc_total_paid_amount": is_ddc_total_paid_cess, "is_ddc_total_amount_difference": is_ddc_total_cess_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_cess',true).is_visible && this. company_setup.custom_cess_visible == '1' && data.total_invoice_cess > 0},

      { "title": this.company_setup.show_Foriegn_hsn_percentage == '0' ? this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_other_tax','Total Other Tax').custom_title : this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns, 'custom_other_tax_name', this.company_setup.custom_other_tax_name).custom_title,
       "invoice_amount": total_invoice_other_tax, "paid_amount": total_paid_other_tax, "difference_amount": total_other_tax_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": is_ddc_total_invoice_other_tax, "is_ddc_total_paid_amount": is_ddc_total_paid_other_tax, "is_ddc_total_amount_difference": is_ddc_total_other_tax_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_other_tax',true).is_visible && this. company_setup.custom_other_tax_visible == '1' && data.total_invoice_other_tax > 0 
      },

      { "title":this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_gst','Total GST').custom_title,
      "invoice_amount": total_invoice_tax, "paid_amount": total_paid_tax, "difference_amount": total_tax_difference, "is_col_span": false, "col_span": '0',
      "is_ddc_total_invoice_amount": is_ddc_total_invoice_tax, "is_ddc_total_paid_amount": is_ddc_total_paid_tax, "is_ddc_total_amount_difference": is_ddc_total_tax_difference,
     is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_gst',true).is_visible && this.company_setup.custom_total_gst_visible == "1"},

      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'grand_total','Grand Total').custom_title,
       "invoice_amount": grand_total_invoice_amount, "paid_amount": grand_total_paid_amount, "difference_amount": grand_total_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": is_ddc_grandTotal_paid_amount, "is_ddc_total_paid_amount": is_ddc_grandTotal_paid_amount, "is_ddc_total_amount_difference": is_ddc_grandTotal_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'grand_total',true).is_visible },

      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'tds_amount','TDS Amount').custom_title,
       "invoice_amount": tds_amount, "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": is_ddc_tds_amount, "is_ddc_total_paid_amount": "", "is_ddc_total_amount_difference": "",
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1' && this.company_setup.hide_invoice_tds_related_fields !='1' && this.company_setup.invoice_raiser_hide_tds=='0', "is_view": (!is_goods && this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_amount',true).is_visible && this.company_setup.invoice_in_summary_table_tds_amount_field_visible == "1" && this.company_setup.hide_invoice_tds_related_fields !='1' && this.company_setup.invoice_raiser_hide_tds=='0') ?true:false
       },

      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'previous_tds_amount','Previous TDS Amount').custom_title,
       "invoice_amount": previous_tds_amount, "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',
      is_ddc_view:this.is_ddc && this.company_setup.hide_invoice_tds_related_fields !='1' && this.company_setup.invoice_raiser_hide_tds=='0', "is_view": (!is_goods && this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_amount',true).is_visible && this.company_setup.invoice_in_summary_table_previous_tds_amount_field_visible == "1"  && (this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1') && this.company_setup.hide_invoice_tds_related_fields !='1' && this.company_setup.invoice_raiser_hide_tds=='0') ?true:false,
      "is_ddc_total_invoice_amount": is_ddc_previous_tds_amount, "is_ddc_total_paid_amount": "", "is_ddc_total_amount_difference": ""
        },
      { "title": 'Other Charges', "invoice_amount": data.installation_charge, "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',is_ddc_view:this.is_ddc, "is_view": false },
      { "title": 'Freight Cost', "invoice_amount": data.freight_cost, "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',is_ddc_view:this.is_ddc, "is_view": false },
      { "title": 'Discount Value', "invoice_amount": data.discount_value, "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',is_ddc_view:this.is_ddc, "is_view": false },

      { "title": 'Advance Adjusted TDS Amount',
      "invoice_amount": data.advance_adjusted_tds_amount?data.advance_adjusted_tds_amount:'', "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',
      is_ddc_view:this.is_ddc && this.company_setup.hide_invoice_tds_related_fields !='1', "is_ddc_total_invoice_amount": '', "is_ddc_total_paid_amount": '', "is_ddc_total_amount_difference": '',
      "is_view":((data.is_direct !== '1')  && (this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1') && this.company_setup.hide_invoice_tds_related_fields !='1')? true : false
      },
      { "title": 'Advance Amount', "invoice_amount": data.advance_amount?data.advance_amount:'', "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',is_ddc_view:this.is_ddc, "is_view": data.is_direct == '1' ? false : true },
      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'adjusted_amount','Adjusted Amount').custom_title,
       "invoice_amount": data.adjusted_amount, "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": data.is_ddc_adjusted_amount, "is_ddc_total_paid_amount": "", "is_ddc_total_amount_difference": "",
      is_ddc_view:this.is_ddc, "is_view": ( this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_amount',true).is_visible && data.is_direct != '1'  && (this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1'))? true : false
       },
       { "title": 'Total TDS Amount',
       "invoice_amount": total_tds_amount?total_tds_amount:'', "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',
       "is_view":(this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1') && this.company_setup.hide_invoice_tds_related_fields !='1' && this.company_setup.invoice_raiser_hide_tds=='0'?true:false,
       is_ddc_view:this.is_ddc && this.company_setup.hide_invoice_tds_related_fields !='1' && this.company_setup.invoice_raiser_hide_tds=='0', "is_ddc_total_invoice_amount": is_ddc_total_tds_amount, "is_ddc_total_paid_amount": "", "is_ddc_total_amount_difference": "",},
      
       { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'gst_tds_igst','GST TDS IGST Amount').custom_title,
        "invoice_amount": total_gst_tds_igst_amount?total_gst_tds_igst_amount:'', "paid_amount": '', "difference_amount": '',
        "is_view":(total_gst_tds_igst_amount > 0 ? true : false)
       } ,
       { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'gst_tds_cgst','GST TDS CGST Amount').custom_title,
        "invoice_amount": total_gst_tds_cgst_amount?total_gst_tds_cgst_amount:'', "paid_amount": '', "difference_amount": '',
        "is_view":(total_gst_tds_cgst_amount > 0 ? true : false)
       } ,
       { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'gst_tds_sgst','GST TDS SGST Amount').custom_title,
        "invoice_amount": total_gst_tds_sgst_amount?total_gst_tds_sgst_amount:'', "paid_amount": '', "difference_amount": '',
        "is_view":(total_gst_tds_sgst_amount > 0 ? true : false)
       } ,
       { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'gst_tds_ugst','GST TDS UGST Amount').custom_title,
        "invoice_amount": total_gst_tds_ugst_amount?total_gst_tds_ugst_amount:'', "paid_amount": '', "difference_amount": '',
        "is_view":(total_gst_tds_ugst_amount > 0 ? true : false)
       } ,
       { "title": this.webService.getColumnName(this.company_setup.invoice_extra_columns,'proposed_pod_deduction_amount','Proposed POD Deduction Amount'),
       "invoice_amount": this.webService.convertNaN(parseFloat(this.webService.convertNaN(data.pod_deduction_amount))), "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',is_ddc_view:this.is_ddc, "is_view": (this.company_setup.proposed_pod_deduction_amount_visible && data.is_vendor_invoice!=='1'  && (this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1') && this.company_setup.invoice_raiser_hide_tds=='0')? true : false },

       { "title": this.webService.getColumnName(this.company_setup.invoice_extra_columns,'proposed_cod_deduction_amount','Proposed COD Deduction Amount'),
       "invoice_amount": this.webService.convertNaN(parseFloat(this.webService.convertNaN(data.cod_deduction_amount))), "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',is_ddc_view:this.is_ddc, "is_view": (this.company_setup.proposed_cod_deduction_amount_visible && data.is_vendor_invoice!=='1'  && (this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1') && this.company_setup.invoice_raiser_hide_tds=='0')? true : false },

       { "title": this.webService.getColumnName(this.company_setup.invoice_extra_columns,'approved_pod_deduction_amount','Approved POD Deduction Amount'),
       "invoice_amount": this.webService.convertNaN(parseFloat(this.webService.convertNaN(data.approved_pod_deduction_amount))), "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',is_ddc_view:this.is_ddc, "is_view": (this.company_setup.approved_pod_deduction_amount_visible&& !is_approval && data.is_vendor_invoice!=='1'  && (this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1') && this.company_setup.invoice_raiser_hide_tds=='0')? true : false },

       { "title": this.webService.getColumnName(this.company_setup.invoice_extra_columns,'approved_cod_deduction_amount','Approved COD Deduction Amount'),
       "invoice_amount": this.webService.convertNaN(parseFloat(this.webService.convertNaN(data.approved_cod_deduction_amount))), "paid_amount": '', "difference_amount": '', "is_col_span": false, "col_span": '0',is_ddc_view:this.is_ddc, "is_view": (this.company_setup.approved_cod_deduction_amount_visible && !is_approval && data.is_vendor_invoice!=='1'  && (this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1') && this.company_setup.invoice_raiser_hide_tds=='0')? true : false },
    )
    this.commonVariableList.totalList = {};
    this.commonVariableList.totalList.amount = grand_total ? grand_total : '';
    this.commonVariableList.totalList.is_ddc_amount = is_ddc_grandTotal ? is_ddc_grandTotal : '';
    this.commonVariableList.totalList.is_view = true;
    this.commonVariableList.totalList.title =this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_payable','Total Payable').custom_title;
    if(this.company_setup.invoice_raiser_hide_tds=='1') {
      this.commonVariableList.totalList.is_view = false;
    }
    data.sectionList=data.sections?data.sections:(data.sectionList?data.sectionList:[])
    this.commonVariableList.totalList.is_ddc_view = false
    if(this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' || this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1') {
      this.commonVariableList.totalList.is_ddc_view = true;
    }
    if(this.company_setup.invoice_raiser_hide_tds=='1') {
      this.commonVariableList.totalList.is_ddc_view = false;
    }
    this.commonVariableList.totalList.round_grandTotal = round_grandTotal; // data.round_grandTotal ? data.round_grandTotal : ""
    this.commonVariableList.totalList.roundedOff_grandTotal = roundedOff_grandTotal; //data.roundedOff_grandTotal ? data.roundedOff_grandTotal : ""
    this.commonVariableList.totalList.is_round_off_view = this.company_setup.round_off_fields_visible_in_invoice == "1" ? true : false;
    // if(this.company_setup.invoice_raiser_hide_tds=='1') {
    //   this.commonVariableList.totalList.is_round_off_view = false;
    // }
    if (data.sectionList.length>0) {
      let sl_no: number = 1;
      for (let i of data.sectionList) {
        i.total_gross_amount = i.total_gross_amount ? i.total_gross_amount : '';
        if(i.is_po_section=='1')
        {
          i.total_gross_amount='-';
          // //console.log('url='+url);
          if(url=='/update-invoice'||url=='update-invoice')
          {
            // //console.log('update inv');
            i.advance_adjusted_amount= i.last_advance_adjusted_amount?i.last_advance_adjusted_amount:(i.advance_adjusted_amount?i.advance_adjusted_amount:'')
       i.advance_adjusted_tds_amount= i.last_advance_adjusted_tds_amount?i.last_advance_adjusted_tds_amount:(i.advance_adjusted_tds_amount?i.advance_adjusted_tds_amount:'')
        i.total_gross_amount=i.last_total_gross_amount?i.last_total_gross_amount:(i.total_gross_amount?i.total_gross_amount:'')
        i.total_tds_amount=i.last_total_tds_amount?i.last_total_tds_amount:(i.total_tds_amount?i.total_tds_amount:'')
        i.tds_amount=i.last_tds_amount?i.last_tds_amount:(i.tds_amount?i.tds_amount:'')
        i.tds_deduction=i.last_tds_deduction?i.last_tds_deduction:(i.tds_deduction?i.tds_deduction:'')


          }
        }

        i.sl_no = sl_no;
         i.is_view = true;
          sl_no++;
        i.class_name=i.is_po_section=='1'?'posection':'';
      }
    }
    if(this.commonVariableList.extraGrandColumnList)
    {
      for(const i of this.commonVariableList.extraGrandColumnList)
      {
        if(i.value=='po_no' && data.is_multi_grn_invoice=='1')
        {
          i.is_view=true;
        }
        if(i.value=='po_no' && data.is_multi_grn_invoice=='0')
        {
          i.is_view=false;
        }

        if(i.value=='vendor_tds_rate' && data.is_direct=='1')
        {
          i.is_view=false;
        }
        if(i.value=='vendor_tds_rate' && data.is_direct=='0')
        {
          i.is_view=data.sectionList.some((v)=>{return parseFloat(this.webService.convertNaN(v.vendor_tds_rate))>0});
        }

        if(i.value=='advance_adjusted_amount' && data.is_direct=='1')
        {
          i.is_view=false;
        }
        if(i.value=='advance_adjusted_amount' && data.is_direct=='0')
        {
          i.is_view=data.sectionList.some((v)=>{return parseFloat(this.webService.convertNaN(v.advance_adjusted_amount))>0});
        }
        if(i.value=='advance_adjusted_tds_amount' && data.is_direct=='1')
        {
          i.is_view=false;
        }
        if(i.value=='advance_adjusted_tds_amount' && data.is_direct=='0')
        {
          i.is_view=data.sectionList.some((v)=>{return parseFloat(this.webService.convertNaN(v.advance_adjusted_tds_amount))>0});
        }

        if(i.value=='tds_deduction' && data.is_direct=='1')
        {
          i.is_view=false;
        }
        if(i.value=='tds_deduction' && data.is_direct=='0')
        {
          i.is_view=data.sectionList.some((v)=>{return parseFloat(this.webService.convertNaN(v.tds_deduction))>0});

        }
        let arr = ["vendor_tds_rate", "advance_adjusted_tds_amount", "tds_deduction"]
        if (arr.includes(i.value) && (this.company_setup.hide_approval_name_in_vendor_portal == '1' || this.company_setup.invoice_raiser_hide_tds=='1')) {
          i.is_view = false;
        }

        arr = ["vendor_tds_rate", "advance_adjusted_tds_amount", "tds_deduction"];
        if (arr.includes(i.value) && this.company_setup.invoice_raiser_hide_tds=='1') {
          i.is_view = false;
        }
      }
    }
    this.commonVariableList.extraGrandColumnList=this.commonVariableList.extraGrandColumnList.filter((v)=>{return v.is_view});
    this.commonVariableList.extraItems = data.sectionList ? data.sectionList : [];
    if(this.company_setup.invoice_raiser_hide_tds=='1') {
      this.commonVariableList.extraItems = [];
    }
    let is_vendor = localStorage.getItem('ven_role') == 'vendor' ? "1" : '0';
    if(is_vendor=='1')
    {
      this.commonVariableList.extraItems=[];
      this.commonVariableList.extraGrandColumnList=[];
      data.sectionList=[];
    }
    if(this.country_data.country!=='101')
    {
      // this.commonVariableList.extraItems=[];
    }
    this.makeData();

  }
  showModal(row,tempData,report_id)
{
 switch(report_id)
 {
 case 'dcnotereport':
   this.showDCNote(tempData);
   break;
   case 'invoicereport':
    this.showInvoiceDetails(tempData);
    break;
   default:
     this.toasterService.pop('info','Info','Details not found');
 }
}
recurrenceData:any = {
  tot_inv_amount_ex_tax: 0, tax: 0, tot_inv_amt_incl_tax: "",
  amt_change: "", per_change: "", final_proposed_amt_ex_tax: "", actual_inv_amt_incl_tax: "",
}
  showRecurringInvoice(data) {
    let is_goods: boolean = false;
    this.is_dimension=false;
    this.is_ddc=data.is_different_document_currency=='1'?true:false;
    console.log('hey input'+data.is_different_document_currency+' is_ddc'+this.is_ddc)
    is_goods = data.invoice_items.every((v) => { return v.product_type == 'goods' })
    this.attachment=this.webService.makeAttachment(this.tableDetails.data.tds_attachments);
    this.recurrence_table=this.tableDetails.data.recurring_details?this.tableDetails.data.recurring_details:[]
      this.recurrenceData = {
        tot_inv_amount_ex_tax: 0, tax: 0, tot_inv_amt_incl_tax: "",
        amt_change: "", per_change: "", final_proposed_amt_ex_tax: "", actual_inv_amt_incl_tax: "",
      }
      if (this.recurrence_table) {
        for (let i of this.recurrence_table) {
          this.recurrenceData.tot_inv_amount_ex_tax = parseFloat(this.webService.convertNaN(this.recurrenceData.tot_inv_amount_ex_tax)) + parseFloat(this.webService.convertNaN(i.invoice_amount_excluding_tax))
          this.recurrenceData.tot_inv_amount_ex_tax = this.webService.convertNaN(this.recurrenceData.tot_inv_amount_ex_tax)

          this.recurrenceData.tax = parseFloat(this.webService.convertNaN(this.recurrenceData.tax)) + parseFloat(this.webService.convertNaN(i.invoice_tax))
          this.recurrenceData.tax = this.webService.convertNaN(this.recurrenceData.tax)

          this.recurrenceData.tot_inv_amt_incl_tax = parseFloat(this.webService.convertNaN(this.recurrenceData.tot_inv_amt_incl_tax)) + parseFloat(this.webService.convertNaN(i.invoice_amount_including_tax))
          this.recurrenceData.tot_inv_amt_incl_tax = this.webService.convertNaN(this.recurrenceData.tot_inv_amt_incl_tax)

          this.recurrenceData.amt_change = parseFloat(this.webService.convertNaN(this.recurrenceData.amt_change)) + parseFloat(this.webService.convertNaN(i.amount_change))
          this.recurrenceData.amt_change = this.webService.convertNaN(this.recurrenceData.amt_change)

          this.recurrenceData.final_proposed_amt_ex_tax = parseFloat(this.webService.convertNaN(this.recurrenceData.final_proposed_amt_ex_tax)) + parseFloat(this.webService.convertNaN(i.final_proposed_amount_excluding_tax))
          this.recurrenceData.final_proposed_amt_ex_tax = this.webService.convertNaN(this.recurrenceData.final_proposed_amt_ex_tax)

          this.recurrenceData.actual_inv_amt_incl_tax = parseFloat(this.webService.convertNaN(this.recurrenceData.actual_inv_amt_incl_tax)) + parseFloat(this.webService.convertNaN(i.actual_invoice_amount_excluding_tax))
          this.recurrenceData.actual_inv_amt_incl_tax = this.webService.convertNaN(this.recurrenceData.actual_inv_amt_incl_tax)
        }
      }

    this.commonVariableList.is_goods = data.invoice_items.every((v) => { return v.product_type == 'goods' })
    data.is_account_type = data.is_account_type ? data.is_account_type : '0'
    data.is_customer_allocation_visible = data.is_customer_allocation_visible ? data.is_customer_allocation_visible : '0'
    data.is_department_allocation_visible = data.is_department_allocation_visible ? data.is_department_allocation_visible : '0'
    data.invoice_allocate_to_employee = data.invoice_allocate_to_employee ? data.invoice_allocate_to_employee : ""
    data.is_vendor_invoice=data.is_vendor_invoice?data.is_vendor_invoice:'0';
    data.location_allocation_list = data.location_allocation_list ? data.location_allocation_list : []
    this.commonVariableList.is_deaprtment_list=data.location_allocation_list.length>0?true:false;
    data.department_allocation_list =[]


    data.account_type_field_list = data.account_type_field_list ? data.account_type_field_list : []
    data.customer_allocation_list = data.customer_allocation_list ? data.customer_allocation_list : []
    data.employee_allocation_list = data.employee_allocation_list ? data.employee_allocation_list : []
    if(data.employee_allocation_list){
      for(let d of data.employee_allocation_list) {
        d.name = d.first_name ? `${d.first_name} ${d.last_name} (${d.employee_code})` : "";
        d.amount = d.amount ? d.amount : "";
        d.remarks = d.remarks ? d.remarks : "";
      }
    }
    this.commonVariableList.is_account_type = data.is_account_type == '1' && data.account_type_field_list.length > 0 ? true : false;
    this.commonVariableList.is_customer_allocation_visible = data.is_customer_allocation_visible == '1' ? true : false;
    this.commonVariableList.is_department_allocation_visible = data.is_department_allocation_visible == '1' ? true : false;
    this.commonVariableList.invoice_allocate_to_employee_visible = data.invoice_allocate_to_employee == '1' ? true : false;

    this.commonVariableList.department_allocation_list = data.department_allocation_list ? data.department_allocation_list : []
    this.department_tax_column_visible=this.commonVariableList.department_allocation_list.some((v)=>{return parseFloat(this.webService.convertNaN(v.gst_amount))>0})

    this.commonVariableList.account_type_field_list = data.account_type_field_list ? data.account_type_field_list : []
    this.commonVariableList.customer_allocation_list = data.customer_allocation_list ? data.customer_allocation_list : []
    this.commonVariableList.employee_allocation_list = data.employee_allocation_list ? data.employee_allocation_list : []
    if(this.commonVariableList.customer_allocation_list) {
      this.commonVariableList.customer_allocation_list.forEach((d)=>{
        d.customer_first_name = d.first_name ? d.first_name : "";
        d.customer_last_name = d.last_name ? d.last_name : "";
        d.customer_location_name = d.customer_address ? d.customer_address : "";

      })
    }
    this.is_dimension=this.commonVariableList.department_allocation_list.some((v)=>{return v.dimension_name!='' && v.dimension_name!=null && v.dimension_name!=undefined})
//Start Code : to convert into two digi fater decimal

data.total_invoice_amount = this.webService.convertNaN(data.total_invoice_amount)
data.total_paid_amount = this.webService.convertNaN(data.total_paid_amount)
data.total_amount_difference = this.webService.convertNaN(data.total_amount_difference)

data.total_invoice_sgst = this.webService.convertNaN(data.total_invoice_sgst)
data.total_paid_sgst = this.webService.convertNaN(data.total_paid_sgst)
data.total_sgst_difference = this.webService.convertNaN(data.total_sgst_difference)


data.total_invoice_cgst = this.webService.convertNaN(data.total_invoice_cgst)
data.total_paid_cgst = this.webService.convertNaN(data.total_paid_cgst)
data.total_cgst_difference = this.webService.convertNaN(data.total_cgst_difference)

data.total_invoice_igst = this.webService.convertNaN(data.total_invoice_igst)
data.total_paid_igst = this.webService.convertNaN(data.total_paid_igst)
data.total_igst_difference = this.webService.convertNaN(data.total_igst_difference)

data.total_invoice_cess = this.webService.convertNaN(data.total_invoice_cess)
data.total_paid_cess = this.webService.convertNaN(data.total_paid_cess)
data.total_cess_difference = this.webService.convertNaN(data.total_cess_difference)

data.total_invoice_ugst = this.webService.convertNaN(data.total_invoice_ugst)
data.total_paid_ugst = this.webService.convertNaN(data.total_paid_ugst)
data.total_ugst_difference = this.webService.convertNaN(data.total_ugst_difference)

data.total_invoice_other_tax = this.webService.convertNaN(data.total_invoice_other_tax)
data.total_paid_other_tax = this.webService.convertNaN(data.total_paid_other_tax)
data.total_other_tax_difference = this.webService.convertNaN(data.total_other_tax_difference)


data.total_invoice_tax = this.webService.convertNaN(data.total_invoice_tax)
data.total_paid_tax = this.webService.convertNaN(data.total_paid_tax)
data.total_tax_difference = this.webService.convertNaN(data.total_tax_difference)


data.grand_total_invoice_amount = this.webService.convertNaN(data.grand_total_invoice_amount)
data.grand_total_paid_amount = this.webService.convertNaN(data.grand_total_paid_amount)
data.grand_total_difference = this.webService.convertNaN(data.grand_total_difference)



data.tds_amount = this.webService.convertNaN(data.tds_amount)
data.previous_tds_amount = this.webService.convertNaN(data.previous_tds_amount)
data.installation_charge = this.webService.convertNaN(data.installation_charge)
data.freight_cost = this.webService.convertNaN(data.freight_cost)
data.discount_value = this.webService.convertNaN(data.discount_value)
data.advance_amount = this.webService.convertNaN(data.advance_amount)
data.adjusted_amount = this.webService.convertNaN(data.adjusted_amount)


data.total_invoice_amount = parseFloat(data.total_invoice_amount)
data.total_paid_amount = parseFloat(data.total_paid_amount)
data.total_amount_difference = parseFloat(data.total_amount_difference)

data.total_invoice_sgst = parseFloat(data.total_invoice_sgst)
data.total_paid_sgst = parseFloat(data.total_paid_sgst)
data.total_sgst_difference = parseFloat(data.total_sgst_difference)


data.total_invoice_cgst = parseFloat(data.total_invoice_cgst)
data.total_paid_cgst = parseFloat(data.total_paid_cgst)
data.total_cgst_difference = parseFloat(data.total_cgst_difference)

data.total_invoice_igst = parseFloat(data.total_invoice_igst)
data.total_paid_igst = parseFloat(data.total_paid_igst)
data.total_igst_difference = parseFloat(data.total_igst_difference)

data.total_invoice_cess = parseFloat(data.total_invoice_cess)
data.total_paid_cess = parseFloat(data.total_paid_cess)
data.total_cess_difference = parseFloat(data.total_cess_difference)

data.total_invoice_ugst = parseFloat(data.total_invoice_ugst)
data.total_paid_ugst = parseFloat(data.total_paid_ugst)
data.total_ugst_difference = parseFloat(data.total_ugst_difference)

data.total_invoice_other_tax = parseFloat(data.total_invoice_other_tax)
data.total_paid_other_tax = parseFloat(data.total_paid_other_tax)
data.total_other_tax_difference = parseFloat(data.total_other_tax_difference)


data.total_invoice_tax = parseFloat(data.total_invoice_tax)
data.total_paid_tax = parseFloat(data.total_paid_tax)
data.total_tax_difference = parseFloat(data.total_tax_difference)


data.grand_total_invoice_amount = parseFloat(data.grand_total_invoice_amount)
data.grand_total_paid_amount = parseFloat(data.grand_total_paid_amount)
data.grand_total_difference = parseFloat(data.grand_total_difference)



data.tds_amount = parseFloat(data.tds_amount)
data.previous_tds_amount = parseFloat(data.previous_tds_amount)
data.installation_charge = parseFloat(data.installation_charge)
data.freight_cost = parseFloat(data.freight_cost)
data.discount_value = parseFloat(data.discount_value)
data.advance_amount = parseFloat(data.advance_amount)
data.adjusted_amount = parseFloat(data.adjusted_amount)


data.total_invoice_amount = this.webService.convertNaN(data.total_invoice_amount)
data.total_paid_amount = this.webService.convertNaN(data.total_paid_amount)
data.total_amount_difference = this.webService.convertNaN(data.total_amount_difference)

data.total_invoice_sgst = this.webService.convertNaN(data.total_invoice_sgst)
data.total_paid_sgst = this.webService.convertNaN(data.total_paid_sgst)
data.total_sgst_difference = this.webService.convertNaN(data.total_sgst_difference)


data.total_invoice_cgst = this.webService.convertNaN(data.total_invoice_cgst)
data.total_paid_cgst = this.webService.convertNaN(data.total_paid_cgst)
data.total_cgst_difference = this.webService.convertNaN(data.total_cgst_difference)

data.total_invoice_igst = this.webService.convertNaN(data.total_invoice_igst)
data.total_paid_igst = this.webService.convertNaN(data.total_paid_igst)
data.total_igst_difference = this.webService.convertNaN(data.total_igst_difference)

data.total_invoice_cess = this.webService.convertNaN(data.total_invoice_cess)
data.total_paid_cess = this.webService.convertNaN(data.total_paid_cess)
data.total_cess_difference = this.webService.convertNaN(data.total_cess_difference)

data.total_invoice_ugst = this.webService.convertNaN(data.total_invoice_ugst)
data.total_paid_ugst = this.webService.convertNaN(data.total_paid_ugst)
data.total_ugst_difference = this.webService.convertNaN(data.total_ugst_difference)

data.total_invoice_other_tax = this.webService.convertNaN(data.total_invoice_other_tax)
data.total_paid_other_tax = this.webService.convertNaN(data.total_paid_other_tax)
data.total_other_tax_difference = this.webService.convertNaN(data.total_other_tax_difference)


data.total_invoice_tax = this.webService.convertNaN(data.total_invoice_tax)
data.total_paid_tax = this.webService.convertNaN(data.total_paid_tax)
data.total_tax_difference = this.webService.convertNaN(data.total_tax_difference)


data.grand_total_invoice_amount = this.webService.convertNaN(data.grand_total_invoice_amount)
data.grand_total_paid_amount = this.webService.convertNaN(data.grand_total_paid_amount)
data.grand_total_difference = this.webService.convertNaN(data.grand_total_difference)



data.tds_amount = this.webService.convertNaN(data.tds_amount)
data.previous_tds_amount = this.webService.convertNaN(data.previous_tds_amount)
data.installation_charge = this.webService.convertNaN(data.installation_charge)
data.freight_cost = this.webService.convertNaN(data.freight_cost)
data.discount_value = this.webService.convertNaN(data.discount_value)
data.advance_amount = this.webService.convertNaN(data.advance_amount)
data.adjusted_amount = this.webService.convertNaN(data.adjusted_amount)


data.proposed_pod_deduction_amount=this.webService.convertNaN(data.proposed_pod_deduction_amount);
data.proposed_cod_deduction_amount=this.webService.convertNaN(data.proposed_cod_deduction_amount);
data.approved_pod_deduction_amount=this.webService.convertNaN(data.approved_pod_deduction_amount);
data.approved_cod_deduction_amount=this.webService.convertNaN(data.approved_cod_deduction_amount);

data.proposed_pod_deduction_amount=parseFloat(data.proposed_pod_deduction_amount);
data.proposed_cod_deduction_amount=parseFloat(data.proposed_cod_deduction_amount);
data.approved_pod_deduction_amount=parseFloat(data.approved_pod_deduction_amount);
data.approved_cod_deduction_amount=parseFloat(data.approved_cod_deduction_amount);


data.proposed_pod_deduction_amount=this.webService.convertNaN(data.proposed_pod_deduction_amount);
data.proposed_cod_deduction_amount=this.webService.convertNaN(data.proposed_cod_deduction_amount);
data.approved_pod_deduction_amount=this.webService.convertNaN(data.approved_pod_deduction_amount);
data.approved_cod_deduction_amount=this.webService.convertNaN(data.approved_cod_deduction_amount);

data.mask_total_tds_amount=this.webService.convertNaN(parseFloat(this.webService.convertNaN(data.mask_total_tds_amount)));
data.total_tds_amount=this.webService.convertNaN(parseFloat(this.webService.convertNaN(data.total_tds_amount)));
console.log(data.is_ddc_grandTotal_difference)
// data.total_tds_amount=(parseFloat(data.total_tds_amount)<=0)?data.mask_total_tds_amount:data.total_tds_amount
// End Code : to convert into two digit after decimal

if(this.page_url=='auto-generated-inv')
{
  data.total_invoice_amount=0
  if (data.invoice_items) {
    for (let i of data.invoice_items) {
      data.total_invoice_amount=parseFloat(data.total_invoice_amount)+parseFloat(this.webService.convertNaN(i.invoice_total_price))
      data.total_invoice_amount=this.webService.convertNaN(data.total_invoice_amount)
    }
  }
            data.total_invoice_cess = 0
            data.total_invoice_other_tax = 0
            data.total_invoice_ugst = 0
            data.total_invoice_cgst = 0
            data.total_invoice_sgst = 0
            data.total_invoice_igst = 0
            data.total_invoice_tax =  '0'
            data.grand_total_invoice_amount=data.total_invoice_amount
}
if (this.commonVariableList.columnList) {
  for (let i of this.commonVariableList.columnList) {
    if (i.value == 'title') {
      i.display = "Particulars";
    }
    if (i.value == 'invoice_amount') {
      i.display = this.company_setup.invoice_summary_title.main_title_2?this.company_setup.invoice_summary_title.main_title_2:'';
    }


    if (i.value == 'is_ddc_total_invoice_amount') {
      i.display = (this.company_setup.invoice_summary_title.main_title_2?this.company_setup.invoice_summary_title.main_title_2:'')+"("+data.currency_code+")";
    }
    if (i.value == 'is_ddc_total_paid_amount') {
      i.display = (this.company_setup.invoice_summary_title.main_title_3?this.company_setup.invoice_summary_title.main_title_3:'')+"("+data.currency_code+")";
    }
    if (i.value == 'is_ddc_total_amount_difference') {
      i.display = (this.company_setup.invoice_summary_title.main_title_4?this.company_setup.invoice_summary_title.main_title_4:'')+"("+data.currency_code+")";
    }

    if (i.value == 'is_ddc_total_invoice_amount' && this.is_ddc) {
      i.is_view = true
      i.is_currency = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_invoice_amount' && !this.is_ddc) {
      i.is_view = false
      // i.is_ddc=false
    }

    if (i.value == 'is_ddc_total_paid_amount' && this.is_ddc) {
      i.is_view = true
      i.is_currency = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_paid_amount' && !this.is_ddc) {
      i.is_view = false
      // i.is_ddc=false
    }

    if (i.value == 'is_ddc_total_amount_difference' && this.is_ddc) {
      i.is_view = true
      i.is_currency = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_amount_difference' && !this.is_ddc) {
      i.is_view = false
      // i.is_ddc=false
    }
    if (i.value == 'is_ddc_total_invoice_amount' && this.is_ddc && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1') {
      i.is_view = true
      i.is_currency = false
      console.log('1 true')

      // i.is_ddc=true
    }

    if (i.value == 'is_ddc_total_invoice_amount' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc !='1') {
      i.is_view=false;
      console.log('not true1')

      // i.is_ddc=true
    }

    if (i.value == 'is_ddc_total_paid_amount' && this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1') {
      i.is_view = true
      i.is_currency = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_paid_amount' && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc !='1') {
      i.is_view = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_amount_difference' && this.is_ddc && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1') {
      i.is_view = true
      i.is_currency = false
      // i.is_ddc=true
    }
    if (i.value == 'is_ddc_total_amount_difference' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc !='1') {
      i.is_view = false
      console.log('not true3')
      // i.is_ddc=true
    }

  }
}

let url=window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
let is_approval:boolean=false;
is_approval=(url=='invoice-approval')?true:false;
let is_ddc_previous_tds_amount=data.is_ddc_previous_tds_amount?data.is_ddc_previous_tds_amount:'0'
let tds_amount=data.is_ddc_tds_amount?data.is_ddc_tds_amount:'0'
let total_tds_amount=data.is_ddc_total_tds_amount?data.is_ddc_total_tds_amount:'0'


data.total_invoice_amount = data.total_invoice_amount ? data.total_invoice_amount : '0'
data.conversion_rate = data.conversion_rate ? data.conversion_rate : '1'
data.is_ddc_total_invoice_amount = this.is_ddc ? (data.total_invoice_amount / data.conversion_rate) : data.total_invoice_amount;
data.is_ddc_total_invoice_amount=this.webService.convertNaN(data.is_ddc_total_invoice_amount)

data.total_invoice_cgst = data.total_invoice_cgst ? data.total_invoice_cgst : '0'
data.is_ddc_total_invoice_cgst = this.is_ddc ? (data.total_invoice_cgst / data.conversion_rate) : data.total_invoice_cgst;
data.is_ddc_total_invoice_cgst=this.webService.convertNaN(data.is_ddc_total_invoice_cgst)

data.total_invoice_sgst = data.total_invoice_sgst ? data.total_invoice_sgst : '0'
data.is_ddc_total_invoice_sgst = this.is_ddc ? (data.total_invoice_sgst / data.conversion_rate) : data.total_invoice_sgst;
data.is_ddc_total_invoice_sgst=this.webService.convertNaN(data.is_ddc_total_invoice_sgst)

data.total_invoice_igst = data.total_invoice_igst ? data.total_invoice_igst : '0'
data.is_ddc_total_invoice_igst = this.is_ddc ? (data.total_invoice_igst / data.conversion_rate) : data.total_invoice_igst;
data.is_ddc_total_invoice_igst=this.webService.convertNaN(data.is_ddc_total_invoice_igst)

data.total_invoice_ugst = data.total_invoice_ugst ? data.total_invoice_ugst : '0'
data.is_ddc_total_invoice_ugst = this.is_ddc ? (data.total_invoice_ugst / data.conversion_rate) : data.total_invoice_ugst;
data.is_ddc_total_invoice_ugst=this.webService.convertNaN(data.is_ddc_total_invoice_ugst)

data.total_invoice_cess = data.total_invoice_cess ? data.total_invoice_cess : '0'
data.is_ddc_total_invoice_cess = this.is_ddc ? (data.total_invoice_cess / data.conversion_rate) : data.total_invoice_cess;
data.is_ddc_total_invoice_cess=this.webService.convertNaN(data.is_ddc_total_invoice_cess)

data.total_invoice_other_tax = data.total_invoice_other_tax ? data.total_invoice_other_tax : '0'
data.is_ddc_total_invoice_other_tax = this.is_ddc ? (data.total_invoice_other_tax / data.conversion_rate) : data.total_invoice_other_tax;
data.is_ddc_total_invoice_other_tax=this.webService.convertNaN(data.is_ddc_total_invoice_other_tax)

data.total_invoice_tax = data.total_invoice_tax ? data.total_invoice_tax : '0'
data.is_ddc_total_invoice_tax = this.is_ddc ? (data.total_invoice_tax / data.conversion_rate) : data.total_invoice_tax;
data.is_ddc_total_invoice_tax=this.webService.convertNaN(data.is_ddc_total_invoice_tax)

data.grand_total_invoice_amount = data.grand_total_invoice_amount ? data.grand_total_invoice_amount : '0'
data.is_ddc_grandTotal_paid_amount = this.is_ddc ? (data.grand_total_invoice_amount / data.conversion_rate) : data.grand_total_invoice_amount;
data.is_ddc_grandTotal_paid_amount=this.webService.convertNaN(data.is_ddc_grandTotal_paid_amount)


    this.commonVariableList.items.push(
      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_amount','Total Amount').custom_title,
       "invoice_amount": data.total_invoice_amount, "paid_amount": data.total_paid_amount, "difference_amount": data.total_amount_difference,
       "is_ddc_total_invoice_amount": data.is_ddc_total_invoice_amount, "is_ddc_total_paid_amount": data.is_ddc_total_paid_amount, "is_ddc_total_amount_difference": data.is_ddc_total_amount_difference,
       "is_col_span": false, "col_span": '0',
       is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_amount',true).is_visible },

      { "title":this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_sgst','Total SGST').custom_title,
       "invoice_amount": data.total_invoice_sgst, "paid_amount": data.total_paid_sgst, "difference_amount": data.total_sgst_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": data.is_ddc_total_invoice_sgst, "is_ddc_total_paid_amount": data.is_ddc_total_paid_sgst, "is_ddc_total_amount_difference": data.is_ddc_total_sgst_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_sgst',true).is_visible && this. company_setup.custom_sgst_visible == '1' },

      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_cgst','Total CGST').custom_title,
       "invoice_amount": data.total_invoice_cgst, "paid_amount": data.total_paid_cgst, "difference_amount": data.total_cgst_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": data.is_ddc_total_invoice_cgst, "is_ddc_total_paid_amount": data.is_ddc_total_paid_cgst, "is_ddc_total_amount_difference": data.is_ddc_total_cgst_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_cgst',true).is_visible && this. company_setup.custom_cgst_visible == '1' },

      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_igst','Total IGST').custom_title,
       "invoice_amount": data.total_invoice_igst, "paid_amount": data.total_paid_igst, "difference_amount": data.total_igst_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": data.is_ddc_total_invoice_igst, "is_ddc_total_paid_amount": data.is_ddc_total_paid_igst, "is_ddc_total_amount_difference": data.is_ddc_total_igst_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_igst',true).is_visible && this. company_setup.custom_igst_visible == '1' },

      { "title":this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_ugst','Total UGST').custom_title,
       "invoice_amount": data.total_invoice_ugst, "paid_amount": data.total_paid_ugst, "difference_amount": data.total_ugst_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": data.is_ddc_total_invoice_ugst, "is_ddc_total_paid_amount": data.is_ddc_total_paid_ugst, "is_ddc_total_amount_difference": data.is_ddc_total_ugst_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_ugst',true).is_visible && this. company_setup.custom_ugst_visible == '1' },

      { "title":this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_cess','Total CESS').custom_title,
       "invoice_amount": data.total_invoice_cess, "paid_amount": data.total_paid_cess, "difference_amount": data.total_cess_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": data.is_ddc_total_invoice_cess, "is_ddc_total_paid_amount": data.is_ddc_total_paid_cess, "is_ddc_total_amount_difference": data.is_ddc_total_cess_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_cess',true).is_visible && this. company_setup.custom_cess_visible == '1' },

      { "title":this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_other_tax','Total Other Tax').custom_title,
       "invoice_amount": data.total_invoice_other_tax, "paid_amount": data.total_paid_other_tax, "difference_amount": data.total_other_tax_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": data.is_ddc_total_invoice_other_tax, "is_ddc_total_paid_amount": data.is_ddc_total_paid_other_tax, "is_ddc_total_amount_difference": data.is_ddc_total_other_tax_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_other_tax',true).is_visible && this. company_setup.custom_other_tax_visible == '1' 
    },

      { "title":this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_gst','Total GST').custom_title,
      "invoice_amount": data.total_invoice_tax, "paid_amount": data.total_paid_tax, "difference_amount": data.total_tax_difference, "is_col_span": false, "col_span": '0',
      "is_ddc_total_invoice_amount": data.is_ddc_total_invoice_tax, "is_ddc_total_paid_amount": data.is_ddc_total_paid_tax, "is_ddc_total_amount_difference": data.is_ddc_total_tax_difference,
     is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'total_gst',true).is_visible && this.company_setup.custom_total_gst_visible == "1"},

      { "title": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'grand_total','Grand Total').custom_title,
       "invoice_amount": data.grand_total_invoice_amount, "paid_amount": data.grand_total_paid_amount, "difference_amount": data.grand_total_difference, "is_col_span": false, "col_span": '0',
       "is_ddc_total_invoice_amount": data.is_ddc_grandTotal_paid_amount, "is_ddc_total_paid_amount": data.is_ddc_grandTotal_paid_amount, "is_ddc_total_amount_difference": data.is_ddc_grandTotal_difference,
      is_ddc_view:this.is_ddc && this.company_setup.in_invoice_is_paid_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_invoice_amount_visible_for_ddc =='1' && this.company_setup.in_invoice_is_debit_amount_visible_for_ddc =='1', "is_view": this.webService.returnData(this.company_setup.invoice_summary_title.main_title_1_columns,'grand_total',true).is_visible },


    )
    this.commonVariableList.totalList = {};
     this.commonVariableList.totalList.is_ddc_view = false
      this.commonVariableList.totalList.is_view=false
    this.commonVariableList.extraGrandColumnList=[]
    this.commonVariableList.extraItems = [];
    let is_vendor = localStorage.getItem('ven_role') == 'vendor' ? "1" : '0';
    if(is_vendor=='1')
    {
      this.commonVariableList.extraItems=[];
      this.commonVariableList.extraGrandColumnList=[];
      data.sectionList=[];
    }
    if(this.country_data.country!=='101')
    {
      // this.commonVariableList.extraItems=[];
    }
    this.makeData();

  }

  showAndroidInvoice(data)
  {
    this.commonVariableList.items=[];
    this.commonVariableList.extraItems=[];
    this.commonVariableList.totalList = {};
  }
  ngAfterViewInit()
  {
  }
  Garnd_Table_Visible:boolean=true;
  is_Garnd_Table_Visible()
  {
    let status:boolean=true;
 switch (this.page_url) {
   case 'update-invoice':
     status=false;
     break;
   default:
    status=true;
     break;
 }
 this.Garnd_Table_Visible=status;
}
   isThisVisible(id)
  {
     if(id==''||id==undefined)
    {

 return false
    }
    // //console.log(id);
     return this.company_setup.irn_grn_other_info.some((v)=>{return v.id==id && (v.is_visible_on_irn||v.is_visible_on_irn)})
   }
   getVisibleColspan(){
    let visibleCount = 0;
    this.company_setup.irn_grn_other_info.slice(0, 5).forEach((field) => {
      if (field.is_visible_on_irn) {
        visibleCount++;
      }
    });
    return visibleCount === 0 ? 1 : visibleCount;
  }
   makeData()
   {
     if(this.commonVariableList.items)
     {
       for(const i of this.commonVariableList.items)
       {
         if(i.is_currency==undefined)
         {
           i.is_currency=true;
         }
       }
     }
     if(this.commonVariableList.extraItems)
     {
       for(const i of this.commonVariableList.extraItems)
       {
        i.class_name=i.is_po_section=='1'?'posection':'';
       }
     }
   }
   adhoc_getColumnName(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (this.company_setup.po_adhoc_advance_payment.length == undefined || this.company_setup.po_adhoc_advance_payment.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];
    temp = this.company_setup.po_adhoc_advance_payment.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  adhoc_is_column_visible(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }

    if (this.company_setup.po_adhoc_advance_payment.length == undefined || this.company_setup.po_adhoc_advance_payment.length <= 0) {
      return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = this.company_setup.po_adhoc_advance_payment.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_visible ? temp[0].is_visible : false
  }
  getFile(url)
  {
    if(url!=''&&url!=null&&url!=undefined)
    {
      window.open(url,'_blank');
    }
  }
  IsJeVisible(key)
{ return  this.company_setup.invoiceJESettings.length>0?(this.company_setup.invoiceJESettings.some((v)=>{return v.key==key && v.is_visible})):false;
}
getJEName(key)
{
  return  this.company_setup.invoiceJESettings.length>0?(this.company_setup.invoiceJESettings.some((v)=>{return v.key==key})?this.company_setup.invoiceJESettings.filter((v)=>{return v.key==key})[0].custom_name:''):''
}
showInvoiceDetails(d)
{
  this.commonVariableList.modalDetails = { "data": { "id": d.actual_invoice_id?d.actual_invoice_id:'','is_this_invoice_no':0}, "id": "invoicereport", "name": 'D/C Details', "Desscription": 'PO', "is_view": true };
  this.commonVariableList.modalDetails.is_view = true;
}

  showRfqData(data) {
    this.commonVariableList.items = [];
    this.commonVariableList.totalList = {};
    this.commonVariableList.extraItems = [];
    this.commonVariableList.items = []
  }

  // Check if allocable cost is enabled
  isAllocableCostEnabled(): boolean {
    if (!this.tableDetails || !this.tableDetails.data) {
      return false;
    }
    // Check multiple possible formats for is_allocable_cost
    const isAllocableCost = this.tableDetails.data.is_allocable_cost == '1' || 
                            this.tableDetails.data.is_allocable_cost == 1 || 
                            this.tableDetails.data.is_allocable_cost == true ||
                            this.tableDetails.data.is_allocable_cost === 'true' ||
                            String(this.tableDetails.data.is_allocable_cost) === '1';
    return isAllocableCost;
  }

  // Get total cost line amount for allocable cost
  getTotalCostLineAmount(currencyType: string): number {
    if (!this.tableDetails.data || !this.tableDetails.data.allocable_cost_items || this.tableDetails.data.allocable_cost_items.length === 0) {
      return 0;
    }
    let total = 0;
    for (let costLine of this.tableDetails.data.allocable_cost_items) {
      if (currencyType === 'po_currency') {
        total += parseFloat(this.webService.convertNaN(costLine.planned_amount_in_po_currency)) || 0;
      } else {
        total += parseFloat(this.webService.convertNaN(costLine.planned_amount_in_base_currency)) || 0;
      }
    }
    return total;
  }

  // Get total landed cost
  getTotalLandedCost(): number {
    if (!this.tableDetails.data) {
      return 0;
    }
    const isAllocableCost = (this.tableDetails.data.is_allocable_cost == '1' || 
                             this.tableDetails.data.is_allocable_cost == 1 || 
                             this.tableDetails.data.is_allocable_cost == true);
    if (!this.company_setup || this.company_setup.enable_allocable_cost_direct_po != '1' || !isAllocableCost) {
      return 0;
    }
    // Use grandTotal (which is the final total with tax) - same as what's displayed in Grand Total row
    const baseTotal = parseFloat(this.webService.convertNaN(this.tableDetails.data.grandTotal || this.tableDetails.data.grand_total || 0)) || 0;
    const costLinesTotal = this.getTotalCostLineAmount('base_currency');
    return baseTotal + costLinesTotal;
  }

  // Get total landed cost for foreign currency
  getTotalLandedCostForeign(): number {
    if (!this.tableDetails.data || !this.tableDetails.data.is_different_document_currency || (this.tableDetails.data.is_different_document_currency != '1' && this.tableDetails.data.is_different_document_currency != true)) {
      return 0;
    }
    const foreignTotal = parseFloat(this.webService.convertNaN(this.tableDetails.data.foreign_final_total || 0)) || 0;
    const isAllocableCost = (this.tableDetails.data.is_allocable_cost == '1' || 
                             this.tableDetails.data.is_allocable_cost == 1 || 
                             this.tableDetails.data.is_allocable_cost == true);
    if (!this.company_setup || this.company_setup.enable_allocable_cost_direct_po != '1' || !isAllocableCost) {
      return foreignTotal;
    }
    const costLinesTotal = this.getTotalCostLineAmount('po_currency');
    return foreignTotal + costLinesTotal;
  }

 

}



// WEBPACK FOOTER //
// /codebuild/output/src3621702521/src/src/app/generic-ui-components/generic-grand-table/generic-grand-table.component.ts